(function($){
    var $nlWallSettings;
    var nlWall;

    var $nlWallRecognizeUrlSettings, $nlWallRecognizeUrlOriginal;
    var nlWallRecognizeUrl;

    var $nlWallUpdateSettings, $nlWallUpdateOriginal;
    var nlWallUpdate;

    var $nlWallAlbumSettings, $nlWallAlbumOriginal;
    var nlWallAlbum;

    var $nlWallDocumentPreviewSettings, $nlWallDocumentPreviewOriginal;
    var nlWallDocumentPreview;

    var $nlWallMenuSettings, $nlWallMenuOriginal;
    var nlWallMenu;

    var nlWallHelper = {
        with_params:{},
        wall_dates:[],
        wall_dates_binding:null,
        server_date_helper:null,
        server_date:null,
        set_with_params:function($withParams){
            this.with_params = $withParams;
        },
        get_with_params:function(){
            return this.with_params;
        },
        get_visibles_in:function($type, $in){
            var $showing = 0;
            $($in).each(function(){
                if($(this).data('type') == $type){
                    $showing++;
                }
            });
            return $showing;
        },
        get_post_type:function($level){
            if($level > 1){
                return 'sub-comment';
            }else
            if($level == 1){
                return 'comment';
            }else
            if($level == 0){
                return 'post';
            }
        },
        set_server_date:function($serverDate){
            this.server_date_helper = new Date();
            this.server_date = new Date($serverDate);
        },
        get_server_date:function(){
            var $now  = new Date().getTime();
            var $diff = $now - this.server_date_helper.getTime();
            var $date = this.server_date.getTime() + $diff;
            return new Date($date);
        },
        set_wall_dates:function($postIds){
            this.wall_dates = $postIds;
        },
        get_wall_dates:function(){
            return this.wall_dates;
        },
        wall_date:function(cback){
            var $wallDate = libs.memoryGet('wall_date');
            if($wallDate){
                try{
                    $wallDate.abort();
                }catch($e){

                }
            }
            $wallDate = $.ajax({
                url:location.href,
                method: "GET",
                cache:false,
                dataType: "html",
                success: function ($data, $status, $response) {
                    var $dateString = $response.getResponseHeader('date');
                    if ($dateString.indexOf('GMT')) {
                        $dateString = $dateString.replace('GMT','');
                    }
                    nlWallHelper.set_server_date($dateString);
                    nlWallHelper.wall_date_html();
                    if(cback != undefined){
                        cback();
                    }
                }
            });
            libs.memorySave('wall_date', $wallDate);
        },
        wall_date_html:function(){
            var $refreshEverySeconds = 1;
            var $now = nlWallHelper.get_server_date().getTime();
            var $wallDates = nlWallHelper.get_wall_dates();
            for(var $i in $wallDates){
                var $key = $wallDates[$i];
                var $ele = $(document).find('.post-date[data-id="'+$key+'"]');
                if($ele.length > 0){
                    var $val = $ele.data('postdate');
                    var $newDate = $val.split(' ');
                    var $yearMonthDay = $newDate[0];
                    $yearMonthDay = $yearMonthDay.split('-');
                    var $HourMinuteSecond = $newDate[1];
                    $HourMinuteSecond = $HourMinuteSecond.split(':');
                    var $date = new Date($yearMonthDay[0], $yearMonthDay[1] - 1, $yearMonthDay[2], $HourMinuteSecond[0], $HourMinuteSecond[1], $HourMinuteSecond[2]);
                    var $second = $date.getSeconds();
                    $second = $second <= 9 ? '0' + $second : $second;
                    var $minute = $date.getMinutes();
                    $minute = $minute <= 9 ? '0' + $minute : $minute;
                    var $hour = $date.getHours();
                    $hour = $hour <= 9 ? '0' + $hour : $hour;
                    var $day = $date.getDate();
                    $day = $day <= 9 ? '0' + $day : $day;
                    var $month = $date.getMonth() + 1;
                    $month = $month <= 9 ? '0' + $month : $month;
                    var $year = $date.getFullYear();
                    var $postDate =  $year + '-' + $month + '-' + $day + ' ' + $hour + ':'+ $minute + ':' + $second;
                    $date = $date.getTime();
                    var $diffSeconds = Math.floor(($now - $date)/1000);
                    var $diffMinutes = Math.floor($diffSeconds/60);
                    var $diffHours = Math.floor($diffMinutes/60);
                    var $diffDays = Math.floor($diffHours/24);
                    var $chtml = '';
                    if($diffDays == 0 && $diffHours == 0 && $diffMinutes == 0){
                        $chtml = $diffSeconds == 1 ? $diffSeconds + ' second ago' : $diffSeconds + ' seconds ago';
                    }else
                    if ($diffDays == 0 && $diffHours == 0){
                        $chtml = $diffMinutes == 1 ? $diffMinutes + ' minute ago' : $diffMinutes + ' minutes ago';
                    }else
                    if ($diffDays == 0){
                        $chtml = $diffHours == 1 ? $diffHours + ' hour ago' : $diffHours + ' hours ago';
                    }else
                    if($diffDays < 30){
                        $chtml = $diffDays == 1 ? $diffDays + ' day ago' : $diffDays + ' days ago';
                    }else{
                        $date = $(document).find('.post-date[data-id="'+$key+'"]').data('postdate');
                        //$chtml =  moment.utc($date, 'YYYY-MM-DD HH:mm:ss').local().format('MMMM, DD YYYY hh:mm A');
                        $chtml =  'Over 30 days ago';
                    }
                    if($ele.html() != $chtml){
                        $ele.data('postdate', $postDate).html($chtml);
                    }
                }
            }
            try{
                clearTimeout(this.wall_dates_binding);
            }catch($e){}
            this.wall_dates_binding = setTimeout(function(){
                nlWallHelper.wall_date_html();
            }, ($refreshEverySeconds * 1000));
        },
    };
    var nlWallHtml = {
        load_more:function(){
            var $chtml = '' +
                '<div class="card card-aboutbox card-box mb-4 btn-load-more-container">' +
                '   <div class="d-flex p-0 border-bottom">' +
                '       <button class="btn mx-auto btn-load-more w-100 with-tooltip" title="Load more posts ...">' +
                '           <img src="/bimg/NursesLounge/more-horizontal.png">' +
                '       </button>' +
                '   </div>' +
                '</div>';
            return $chtml;
        },
        post:function($v){
            var $postId = $v.id;
            var $postLevel = $v.level;
            var $postDate = $v.date;
            var $postLongDate = moment.utc($postDate, 'YYYY-MM-DD HH:mm:ss').local().format('MMMM, DD YYYY hh:mm A');
            var $postType = nlWallHelper.get_post_type($postLevel);
            var $postByLounge = $v.lounge && $v.lounge.key;
            var $postImage = $postByLounge ? $v.lounge.logo_root_lounge : $v.user.profile_image_root_wall;
            var $postImageLink = $postByLounge ? $v.lounge.link : $v.user.profile_url;
            var $postName = $postByLounge ? $v.lounge.name : $v.user.first_name+' '+$v.user.last_name;
            $postName = $postName.length > 75 ? $postName.substr(0, 75) + '...' : $postName;
            var $profileImage = $v.user.my_image_root_wall;
            var $profileImageLink = $v.user.my_profile_url;
            var $postContent = $v.post;
            $postContent = libs.replacePerBreaklines($postContent);
            $postContent = libs.convertUrlToLink($postContent);
            var $announcement = $v.announcement;
            //item, options, post-content
            var $chtml = '';
            $chtml+= '' +
                '<div class="card card-aboutbox card-box mb-4 item" data-id="'+$postId+'" data-level="'+$postLevel+'" data-type="'+$postType+'">' +
                '    <div class="d-flex p-3 border-bottom">' +
                '        <div class="mr-3">' +
                '            <img src="'+$postImage+'" data-link="'+$postImageLink+'" class="post-image" alt="profile image">' +
                '        </div>' +
                '        <div class="align-self-center w-100">' +
                '            <h4 class="float-left m-3 font-responsive post-name" data-link="'+$postImageLink+'">'+$postName+'</h4>' +
                '            <p class="float-right m-3 font-responsive post-date" data-id="'+$postId+'" data-postdate="'+$postDate+'" data-postlongdate="'+$postLongDate+'">'+$postLongDate+'</p>' +
                '        </div>' +
                '        <div class="align-self-center">' +
                '            <a href="javascript:void(0)" class="options with-tooltip" title="Options" data-id="'+$postId+'" data-level="'+$postLevel+'">' +
                '                <img src="/bimg/NursesLounge/more-horizontal-back.png" alt="option">' +
                '            </a>' +
                '        </div>' +
                '    </div>' +
                '    <div class="card-body px-0">';
            if($announcement){
                $chtml+= '' +
                    '<div class="row">' +
                    '<div class="col-1 m-1">';
                switch($announcement){
                    case 'message':
                        $chtml+= '<img src="/bimg/NursesLounge/megaphone-button.png" class="announcement-img">';
                        break;
                    case 'calendar':
                        $chtml+= '<img src="/bimg/NursesLounge/calendar-button.png" class="announcement-img">';
                        break;
                }
                switch($announcement){
                    case 'message':
                        $chtml+= '' +
                            '</div>' +
                            '<div class="col-10 mt-md-5 mt-3 mx-0 px-0">' +
                            '<h5 class="announcement-txt font-responsive">Announcement</h5>' +
                            '</div>'+
                            '</div>';
                        break;
                    case 'calendar':
                        $chtml+= '' +
                            '</div>' +
                            '<div class="col-10 mt-md-5 mt-3 mx-0 px-0">' +
                            '<h5 class="announcement-txt font-responsive">Calendar</h5>' +
                            '</div>'+
                            '</div>';
                        break;
                }
            }
            $chtml+= '' +
                '        <div>' +
                '            <p class="px-3 pt-3 font-responsive post-content">' +
                $postContent +
                '            </p>' +
                nlWallHtml.documents($v) +
                nlWallHtml.links($v) +
                nlWallHtml.references($v) +
                nlWallHtml.likes($v) +
                nlWallHtml.reply($v) +
                '           <div class="comments" data-id="'+$postId+'">' +
                nlWallHtml.threads($v) +
                '           </div>'+
                '           <div class="row thread">' +
                '               <a href="javascript:void(0)" class="open-thread w-100 text-center with-tooltip" title="... Read more" data-parent_id="0" data-id="'+$postId+'" data-level="'+$postLevel+'">' +
                '                   ... Read more' +
                '               </a>' +
                '           </div>' +
                '       </div>' +
                '    </div>' +
                '</div>';

            return $chtml;
        },
        documents:function($v, $action){
            var $chtml = '';
            $action = $action != undefined ? $action : 'readonly';
            $.each($v.documents, function ($si, $sv){
                var $id = $action == 'edit' ? $sv.document.id : $sv.id;
                var $documentId = $sv.document && $sv.document.id ? $sv.document.id : null;
                var $thumb = $sv.document ? $sv.document.document_thumb_root : '';
                var $fileType = $sv.document ? $sv.document.file_type : '';
                var $name = $sv.document ? $sv.document.name : '';

                //website-attach, document-was-deleted
                if($documentId){
                    libs.memorySave($fileType+$id, $sv.document);
                    $chtml += '' +
                        '<div class="website-attach attach" ' +
                        'data-id="'+$id+'" ' +
                        'data-filetype="'+$fileType+'" ' +
                        'data-type="website-document" ' +
                        '>';
                }else{
                    $chtml += '' +
                        '<div class="website-attach" ' +
                        'data-id="'+$id+'" ' +
                        'data-type="website-document" ' +
                        '>';
                }
                $chtml += '<div class="float-left block w-100">';
                if($action == 'edit') {
                    $chtml +=
                        '<div class="m-2 d-block">' +
                        '   <i class="float-right fa fa-close cancel with-tooltip" title="Delete"></i>' +
                        '</div>';
                }
                $chtml +='<div class="m-2 d-block text-center soft">' +
                            $name +
                         '</div>';
                if($documentId) {
                    $chtml += '' +
                        '    <div class="block row m-0 p-0">' +
                        '        <div class="row m-0 p-2">' +
                        '            <img src="'+$thumb+'" class="img-fluid mx-auto">' +
                        '        </div>' +
                        '    </div>';
                }else{
                    $chtml += '' +
                        '    <div class="block row m-0 p-0">' +
                        '        <div class="row m-0 p-2 text-center d-block document-was-deleted">' +
                        '           This document was deleted'+
                        '           <i class="fa fa-exclamation-triangle"></i>' +
                        '        </div>' +
                        '    </div>';
                }
                $chtml += '</div>' +
                    '</div>';
            });
            return $chtml;
        },
        links:function($v, $action){
            var $chtml = '';
            $action = $action != undefined ? $action : 'readonly';
            $.each($v.links, function ($si, $sv){
                var $link = $sv.link;
                var $linkId = $sv.links_id;
                var $linkPosition = $link.position;
                var $linkUrl = $link.patternUrl;
                var $linkImage = $link.image;
                var $linkContent = $link.content != "" ? $link.content : $linkUrl;
                $linkContent = $("<div></div>").html($linkContent).text();
                var $linkTitle = $link.title != "" ? $link.title : $linkUrl;
                $linkTitle = $("<div></div>").html($linkTitle).text();

                //website-link
                $chtml += '' +
                    '<div class="website-link attach d-inline-block w-100 '+$linkPosition+'"' +
                    ' data-id="'+$linkId+'"' +
                    ' data-url="'+$linkUrl+'"' +
                    ' data-filetype="link"' +
                    ' data-type="website-thumb">'+
                    '   <div class="float-left block w-100">';
                if($action == 'edit') {
                    $chtml +=
                        '   <div class="m-2 d-block">' +
                        '       <i class="float-right fa fa-close cancel with-tooltip" title="Delete"></i>' +
                        '   </div>';
                }
                $chtml += '' +
                    '        <div class="left float-left mr-2">' +
                    '            <img src="'+$linkImage+'" class="img-fluid">' +
                    '        </div>' +
                    '        <div class="right float-left">' +
                    '            <div class="mb-1 soft font-responsive">' +
                    $linkTitle+
                    '            </div>' +
                    '            <div class="text-justify m-2 font-responsive">' +
                    $linkContent+
                    '            </div>' +
                    '        </div>' +
                    '    </div>' +
                    '</div>';
            });
            return $chtml;
        },
        references:function($v){
            var $chtml = '';
            if($v.lounge_wall){

                var $postByLoungeKey = $v.lounge.key;
                var $postByLoungeWallKey = $v.lounge_wall.key;

                if($v.lounge_wall.documents) {
                    $.each($v.lounge_wall.documents, function ($si, $sv) {
                        var $id = $sv.id;
                        var $documentId = $sv.document && $sv.document.id ? $sv.document.id : null;
                        var $thumb = $sv.document ? $sv.document.document_thumb_root : '';
                        var $fileType = $sv.document ? $sv.document.file_type : '';
                        var $name = $sv.document ? $sv.document.name : '';

                        //website-attach, document-was-deleted
                        if ($documentId) {
                            $chtml += '' +
                                '<div class="website-attach attach" ' +
                                'data-loungekey="' + $postByLoungeKey + '" ' +
                                'data-loungewallkey="' + $postByLoungeWallKey + '" ' +
                                'data-type="website-reference" ' +
                                '>';
                        } else {
                            $chtml += '' +
                                '<div class="website-attach" ' +
                                'data-loungekey="' + $postByLoungeKey + '" ' +
                                'data-loungewallkey="' + $postByLoungeWallKey + '" ' +
                                'data-type="website-reference" ' +
                                '>';
                        }

                        $chtml +=
                            '<div class="float-left block w-100">' +
                            '   <div class="m-2 d-block text-center soft">' +
                            $name +
                            '   </div>';

                        if ($documentId) {
                            $chtml += '' +
                                '    <div class="block row m-0 p-0">' +
                                '        <div class="row m-0 p-2">' +
                                '            <img src="' + $thumb + '" class="img-fluid mx-auto">' +
                                '        </div>' +
                                '    </div>';
                        } else {
                            $chtml += '' +
                                '    <div class="block row m-0 p-0">' +
                                '        <div class="row m-0 p-2 text-center d-block document-was-deleted">' +
                                '           This document was deleted' +
                                '           <i class="fa fa-exclamation-triangle"></i>' +
                                '        </div>' +
                                '    </div>';
                        }

                        $chtml += '</div>' +
                            '</div>';
                    });
                }
                if($v.lounge_wall.links){
                    $.each($v.lounge_wall.links, function ($si, $sv){
                        var $link = $sv.link;
                        var $linkId = $sv.links_id;
                        var $linkPosition = $link.position;
                        var $linkUrl = $link.patternUrl;
                        var $linkImage = $link.image;
                        var $linkContent = $link.content != "" ? $link.content : $linkUrl;
                        $linkContent = $("<div></div>").html($linkContent).text();
                        var $linkTitle = $link.title != "" ? $link.title : $linkUrl;
                        $linkTitle = $("<div></div>").html($linkTitle).text();

                        //website-link
                        $chtml += '' +
                            '<div class="website-link attach d-inline-block w-100 '+$linkPosition+'"' +
                            ' data-id="'+$linkId+'"' +
                            ' data-url="'+$linkUrl+'"' +
                            ' data-filetype="link"' +
                            ' data-type="website-thumb">'+
                            '   <div class="float-left block w-100">'+
                            '        <div class="left float-left mr-2">' +
                            '            <img src="'+$linkImage+'" class="img-fluid">' +
                            '        </div>' +
                            '        <div class="right float-left">' +
                            '            <div class="mb-1 soft font-responsive">' +
                            $linkTitle+
                            '            </div>' +
                            '            <div class="text-justify m-2 font-responsive">' +
                            $linkContent+
                            '            </div>' +
                            '        </div>' +
                            '    </div>' +
                            '</div>';
                    });
                }
            }
            return $chtml;
        },
        likes:function($v){
            var $postId = $v.id;
            var $myLike = $v.my_like;
            var $likesCount = $v.likes_count;
            var $commentsCount = $v.comments_count;
            var $postByLounge = $v.lounge && $v.lounge.key;
            var $postByLoungeKey = $postByLounge ? $v.lounge.key : 0;
            var $postByLoungeWallKey = $postByLounge  && $v.lounge_wall ? $v.lounge_wall.key : null;
            var $postByLoungeWallCommentsCount = $postByLounge && $v.lounge_wall ? $v.lounge_wall.comments_count : 0;
            var $joinOrView = $postByLounge && $v.lounge_wall && $v.lounge_wall.documents && $v.lounge_wall.documents.length > 0 ? ' or view the attachment.' : '.';
            //share add-like, likes-count, comments-count, share-with

            var $chtml = '' +
                '<div class="menu w-100 d-inline-block share" data-id="'+$postId+'">';
            if($postByLounge && $postByLoungeWallKey) {
                var $commentsTxt = $postByLoungeWallCommentsCount == 1 ? 'comment' : 'comments';
                $chtml += '' +
                    '<div class="float-left">' +
                    '   <div class="m-3">' +
                    '       <a href="/lounge/'+$postByLoungeKey+'/activity/notification/fromWall/loungeWall/'+$postByLoungeWallKey+'">'+$postByLoungeWallCommentsCount+' '+$commentsTxt+'. Join the conversation'+$joinOrView+'</a>' +
                    '   </div>' +
                    '</div>';
            }
            $chtml += '' +
                '    <div class="p-3 float-right">' +
                '        <a href="javascript:void(0)" class="mr-4 add-like with-tooltip" data-id="'+$postId+'" title="Like">';
            if($myLike) {
                $chtml += '<i class="fa fa-heart"></i>';
            }else{
                $chtml += '<i class="fa fa-heart-o"></i>';
            }
            $chtml += '' +
                '            <span class="ml-1 likes-count" data-id="'+$postId+'">'+$likesCount+'</span>' +
                '        </a>';
            if(!$postByLounge) {
                $chtml += '' +
                '        <a href="javascript:void(0)" class="mr-4 comments-focus with-tooltip" data-id="'+$postId+'" title="Comments">' +
                '            <i class="fa fa-comment-o"></i>' +
                '            <span class="ml-1 comments-count" data-id="'+$postId+'" data-count="'+$commentsCount+'">'+$commentsCount+'</span>' +
                '        </a>';
            }
            $chtml += '' +
                '        <a href="javascript:void(0)" class="mr-4 share-with with-tooltip" data-id="'+$postId+'" title="Share">' +
                '            <i class="fa fa-share-alt"></i>' +
                '        </a>';
            if(!$postByLounge) {
                $chtml += '' +
                '        <a href="javascript:void(0)" class="mr-4 reply-post with-tooltip" data-id="' + $postId + '" title="Reply">' +
                '            <i class="fa fa-reply"></i>' +
                '        </a>';
            }
            $chtml += '' +
                '    </div>' +
                '</div>';
            return $chtml;
        },
        reply:function($v){
            var $postId = $v.id;
            var $postLevel = $v.level;
            var $toUserId = $v.user_id;
            var $postType = "post";
            var $postByLounge = $v.lounge && $v.lounge.key;
            var $postImage = $postByLounge ? $v.lounge.logo_root_lounge : $v.user.profile_image_root_wall;
            var $postImageLink = $postByLounge ? $v.lounge.link : $v.user.profile_url;
            var $postName = $postByLounge ? $v.lounge.name : $v.user.first_name+' '+$v.user.last_name;
            $postName = $postName.length > 75 ? $postName.substr(0, 75) + '...' : $postName;
            var $profileImage = $v.user.my_image_root_wall;
            var $profileImageLink = $v.user.my_profile_url;
            var $postContent = libs.replacePerBreaklines($v.post);
            $postContent = libs.convertUrlToLink($postContent);

            //reply, reply-post, wall-update
            var $chtml = '';
            if($postByLounge){
                return $chtml;
            }
            $chtml += '' +
                '<div class="reply" data-id="'+$postId+'">' +
                '    <div class="row m-0 p-0">' +
                '        <div class="col-2 m-1 col-sm-1 col-md-1 col-lg-1 col-xl-1">' +
                '            <img src="'+$profileImage+'" class="img" alt="profile" data-link="'+$profileImageLink+'">' +
                '        </div>' +
                '        <div class="reply-post" data-id="'+$postId+'">' +
                '            <div class="col-9 m-1 col-sm-8 col-md-7 col-lg-7 col-xl-8">' +
                '                <div class="form-group">';
            if($postLevel == 0){
                $chtml += '' +
                    '<textarea rows="1" class="form-control bg-light border-0 post-text" data-id="'+$postId+'" placeholder="Write a comment..."></textarea>';
            }else{
                $chtml += '' +
                    '<textarea rows="1" class="form-control bg-light border-0 post-text" data-id="'+$postId+'" placeholder="Write a reply..."></textarea>';
            }
            $chtml += '' +
                '                </div>' +
                '            </div>' +
                '            <div class="col-12 text-right mb-3 float-right col-sm-3 col-md-3 col-lg-3 col-xl-2 m-0 p-0 d-inline-block">' +
                '                <button type="button" class="btn btn-link pr-1 upload with-tooltip" title="Upload image, document, video..." data-id="'+$postId+'">' +
                '                    <img src="/bimg/NursesLounge/upload.png">' +
                '                </button>' +
                '                <button type="button" class="btn btn-link pr-1 text-muted send-post with-tooltip" title="Send post" data-id="'+$postId+'" data-touserid="'+$toUserId+'" data-level="'+$postLevel+'">' +
                '                    <i class="fa fa-paper-plane-o"></i>' +
                '                </button>' +
                '            </div>' +
                '            <div class="my-2 d-inline-block w-100 preview" data-id="'+$postId+'"></div>' +
                '        </div>' +
                '    </div>' +
                '</div>';

            return $chtml;
        },
        threads:function($v){
            var $chtml = '';
            $chtml += '<ul class="list-group">';
            $.each($v.comments, function($index, $data) {
                $chtml+= nlWallHtml.thread($data);
            });
            $chtml += '</ul>';
            return $chtml;
        },
        thread:function($data){
            var $chtml = '';
            var $postId = $data.id;
            var $postLevel = $data.level;
            var $postDate = $data.date;
            var $postLongDate = moment.utc($postDate, 'YYYY-MM-DD HH:mm:ss').local().format('MMMM, DD YYYY hh:mm A');
            var $postType = nlWallHelper.get_post_type($postLevel);
            var $postByLounge = $data.lounge && $data.lounge.key;
            var $postImage = $postByLounge ? $data.lounge.logo_root_lounge : $data.user.profile_image_root_wall;
            var $postImageLink = $postByLounge ? $data.lounge.link : $data.user.profile_url;
            var $postName = $postByLounge ? $data.lounge.name : $data.user.first_name+' '+$data.user.last_name;
            $postName = $postName.length > 75 ? $postName.substr(0, 75) + '...' : $postName;
            var $profileImage = $data.user.my_image_root_wall;
            var $profileImageLink = $data.user.my_profile_url;
            var $postContent = $data.post;
            $postContent = libs.replacePerBreaklines($postContent);
            $postContent = libs.convertUrlToLink($postContent);

            //item, options, post-content
            $chtml += '' +
                '<li class="list-group-item item" data-id="'+$postId+'" data-level="'+$postLevel+'" data-type="'+$postType+'">' +
                '    <div class="row">' +
                '        <div class="col-1 m-0 p-0">' +
                '            <img src="'+$postImage+'" data-link="'+$postImageLink+'" class="img-fluid" alt="profile image">' +
                '        </div>' +
                '        <div class="col-11 m-0 p-0">' +
                '            <div class="container m-0 p-0">' +
                '                <div class="align-self-center w-100">' +
                '                    <div class="float-right p-3">' +
                '                        <a href="javascript:void(0)" class="options with-tooltip" title="Options" data-id="'+$postId+'" data-level="'+$postLevel+'">' +
                '                            <img src="/bimg/NursesLounge/more-horizontal-back.png" alt="option">' +
                '                        </a>' +
                '                    </div>' +
                '                    <h5 class="float-left m-3 font-responsive post-name" data-link="'+$postImageLink+'">'+$postName+'</h5>' +
                '                    <p class="float-right m-3 font-responsive post-date" data-id="'+$postId+'" data-postdate="'+$postDate+'" data-postlongdate="'+$postLongDate+'">'+$postLongDate+'</p>' +
                '                </div>' +
                '                <div class="col-12 d-inline-block">' +
                '                    <p class="px-3 pt-3 font-responsive post-content">' +
                $postContent +
                '                    </p>' +
                nlWallHtml.documents($data) +
                nlWallHtml.links($data) +
                nlWallHtml.references($data) +
                '                </div>' +
                '            </div>' +
                nlWallHtml.likes($data) +
                nlWallHtml.reply($data) +
                '        </div>' +
                '    </div>' +
                '</li>' +
                '<li class="list-group-item comments" data-id="'+$postId+'">' +
                nlWallHtml.threads($data) +
                '</li>'+
                '<li class="list-group-item thread">' +
                '   <a href="javascript:void(0)" class="float-right open-thread with-tooltip" title="... Read more" data-id="'+$postId+'" data-level="'+$postLevel+'">' +
                '       ... Read more' +
                '   </a>' +
                '</li>';

            return $chtml;
        },
        recognize_preload:function(){
            return '' +
                '<div class="row w-100 m-0 p-0">' +
                '   <div class="col-4 offset-4">' +
                '       <img src="/bimg/NursesLounge/loader.gif" class="img-fluid of-contain">' +
                '       <h4 class="col-12 text-center my-2">Loading ...</h4>'+
                '   </div>' +
                '</div>';
        },
        recognize_url:function($data){
            var $chtml = '';
            $.each($data.data.urls, function ($i, $v){
                var $linkPosition = $v.position;
                var $linkUrl = $v.patternUrl;
                var $linkImage = $v.image;
                var $linkContent = $v.content != "" ? $v.content : $linkUrl;
                var $linkTitle = $v.title != "" ? $v.title : $linkUrl;
                $chtml += '' +
                    '<div class="website-link attach d-inline-block w-100 '+$linkPosition+'"' +
                    ' data-url="'+$linkUrl+'"' +
                    ' data-filetype="link"' +
                    ' data-type="website-thumb">' +
                    '    <div class="float-left block w-100">' +
                    '    <div class="m-2 d-block">' +
                    '       <i class="float-right fa fa-close cancel with-tooltip" title="Delete"></i>' +
                    '    </div>' +
                    '        <div class="left float-left mr-2">' +
                    '            <img src="'+$linkImage+'" class="img-fluid">' +
                    '        </div>' +
                    '        <div class="right float-left">' +
                    '            <div class="mb-1 soft font-responsive">' +
                    $linkTitle+
                    '            </div>' +
                    '            <div class="text-justify m-2 font-responsive">' +
                    $linkContent+
                    '            </div>' +
                    '        </div>' +
                    '    </div>' +
                    '</div>';
            });
            return $chtml;
        },
        update_container:function($action){
            var $chtml = '';
            $chtml += '' +
                '<div class="website-attach" ' +
                'data-filetype="'+$action+'" ' +
                'data-type="website-document" ' +
                '>';
            if($action == 'image'){
                $chtml += '' +
                    '   <div class="image-container"></div>' +
                    '   <input type="file" class="d-none" accept=".jpg, .jpeg, .png, .gif, .jfif">' +
                    '</div>';
            }
            if($action == 'document'){
                $chtml += '' +
                    '   <div class="image-container"></div>' +
                    '   <input type="file" class="d-none" accept=".pdf, .docx, .xlsx, .pptx, .ppt, .csv, .xls, .doc, .txt">' +
                    '</div>';
            }
            if($action == 'video'){
                $chtml += '' +
                    '   <div class="image-container"></div>' +
                    '   <input type="file" class="d-none" accept=".mp4, .avi, .mpg, .mov, .flv, .mkv, .wmv">'+
                    '</div>';
            }
            if($action == 'webcam_image'){
                $chtml += '' +
                    '   <div class="image-container"></div>' +
                    '   <div class="camera-buttons m-4">' +
                    '       <button type="button" class="camera-button btn take-camera-picture active"> Take Picture </button>' +
                    '       <button type="button" class="camera-button btn save-camera-picture"> Save Picture </button>' +
                    '       <button type="button" class="camera-button btn back active"> Back </button>' +
                    '   </div>' +
                    '</div>';
            }
            return $chtml;
        },
        update_preload:function(){
            return '' +
                '<div class="row col-4 offset-4 my-4">' +
                '   <img src="/bimg/NursesLounge/loader.gif" class="img-fluid of-contain">' +
                '   <h4 class="col-12 text-center my-2">Loading ...</h4>'+
                '</div>';
        },
        update_options:function(){
            return '' +
                '<li>' +
                '   <div class="image-buttons m-4">' +
                '       <button type="button" class="image-button action btn active" data-action="save"> Save </button>' +
                '       <button type="button" class="image-button action btn active" data-action="back"> Back </button>' +
                '   </div>' +
                '</li>';
        },
        update_wall:function($documents){
            var $chtml = '';
            var $id = $documents.id ? $documents.id : null;
            var $thumb = $documents.document_thumb_root ? $documents.document_thumb_root : '';
            var $fileType = $documents.file_type ? $documents.file_type : '';
            var $name = $documents.name ? $documents.name : '';

            //website-attach, document-was-deleted
            libs.memorySave($fileType+$id, $documents);
            $chtml += '' +
                '<div class="website-attach attach" ' +
                'data-id="'+$id+'" ' +
                'data-filetype="'+$fileType+'" ' +
                'data-type="website-document" ' +
                '>'+
                '    <div class="float-left block w-100">' +
                '       <div class="m-2 d-block">' +
                '           <i class="float-right fa fa-close cancel" title="Delete"></i>' +
                '       </div>' +
                '       <div class="row m-0 p-0">' +
                '           <img src="'+$thumb+'" class="img-fluid mx-auto">' +
                '       </div>' +
                '    </div>' +
                '</div>';
            return $chtml;
        },
        album_preload:function(){
            return '' +
                '<div class="row col-4 offset-4 my-4">' +
                '   <img src="/bimg/NursesLounge/loader.gif" class="img-fluid of-contain">' +
                '   <h4 class="col-12 text-center my-2">Loading ...</h4>'+
                '</div>';
        },
        album_view_html:function($data){
            var $chtml = '';
            $($data.data.documents).each(function($i, $v){
                $chtml += '' +
                    '<div class="col-lg-2 col-md-3 col-sm-6 item">' +
                    '    <div class="img-box-album">' +
                    '        <div class="img-desc">' +
                    '            <div class="img-contain">' +
                    '                <img class="img-fluid" ' +
                    '                   src="'+$v.document_thumb_root+'?resize=160" ' +
                    '                   data-id="'+$v.id+'" ' +
                    '                   data-name="'+$v.name+'" ' +
                    '                   data-documentroot="'+$v.document_root+'" ' +
                    '                   data-type="'+$v.type+'" ' +
                    '                   data-size="'+$v.size+'" ' +
                    '                   data-filetype="'+$v.file_type+'" ' +
                    '                   data-thumbname="'+$v.thumb_name+'" ' +
                    '                   data-documentthumbroot="'+$v.document_thumb_root+'" ' +
                    '                   data-thumbtype="'+$v.thumb_type+'" ' +
                    '                   data-thumbsize="'+$v.thumb_size+'" ' +
                    '                   data-previewname="'+$v.preview_name+'" ' +
                    '                   data-documentpreviewroot="'+$v.document_preview_root+'" ' +
                    '                   data-previewtype="'+$v.preview_type+'" ' +
                    '                   data-previewsize="'+$v.preview_size+'" ' +
                    '                   data-date="'+$v.date+'" ' +
                    '              >' +
                    '            </div>' +
                    '            <p class="img-title">'+$v.name+'</p>' +
                    '        </div>' +
                    '        <div class="btn-delete">' +
                    '            <img src="/bimg/NursesLounge/trash.png" alt="trash">' +
                    '        </div>' +
                    '    </div>' +
                    '</div>';
            });
            return $chtml;
        },
        wall_menu_popup:function($data, $options, $action){
            $action = $action != undefined ? $action : 'edit';
            var $postId = $data.id;
            var $postLevel = $data.level;
            var $postDate = $data.date;
            var $postLongDate = moment.utc($postDate, 'YYYY-MM-DD HH:mm:ss').local().format('MMMM, DD YYYY hh:mm A');
            var $postType = nlWallHelper.get_post_type($postLevel);
            var $postByLounge = $data.lounge && $data.lounge.key;
            var $postImage = $postByLounge ? $data.lounge.logo_root_lounge : $data.user.profile_image_root_wall;
            var $postImageLink = $postByLounge ? $data.lounge.link : $data.user.profile_url;
            var $postName = $postByLounge ? $data.lounge.name : $data.user.first_name+' '+$data.user.last_name;
            $postName = $postName.length > 75 ? $postName.substr(0, 75) + '...' : $postName;
            var $profileImage = $data.user.my_image_root_wall;
            var $profileImageLink = $data.user.my_profile_url;
            var $postContent = $data.post;
            var $chtml = '' +
                '<div class="post-info-header">' +
                '    <div class="row">'+
                '        <div class="col-6">' +
                '            <div class="post-editor-name post-name" data-link="'+$postImageLink+'">'+$postName+'</div>' +
                '        </div>' +
                '        <div class="col-6 text-right">' +
                '            <div class="post-date-time text-muted post-date">'+$postLongDate+'</div>' +
                '        </div>' +
                '    </div>' +
                '    <div class="bg-light my-3 p-3 rounded font-weight-normal">';
            if($action == 'edit') {
                $postContent = libs.replaceBreaklines($postContent);
                $chtml += '' +
                    '<textarea class="w-100 bg-light post-content">' + $postContent+' </textarea>';
            }else{
                $postContent = libs.replacePerBreaklines($postContent);
                $postContent = libs.convertUrlToLink($postContent);
                $chtml += '' +
                    '<p>' + $postContent + '</p>';
            }
            $chtml += ''+
                '    </div>' +
                '    <div class="post-media">';
            $chtml +=
                nlWallHtml.documents($data, $action) +
                nlWallHtml.links($data, $action) +
                nlWallHtml.references($data) +
                '    </div>' +
                '    <div class="menu-options mt-3">';
            $.each($options, function($i, $v){
                $chtml += '<button class="btn btn-save btnAnimate w-100 option my-2" data-action="'+$i+'">'+$v+'</button>';
            });
            $chtml += ''+
                '    </div>';
            '</div>';

            return $chtml;
        },
        wall_menu_preload:function(){
            return '' +
                '<div class="row col-4 offset-4 my-4">' +
                '   <img src="/bimg/NursesLounge/loader.gif" class="img-fluid of-contain">' +
                '   <h4 class="col-12 text-center my-2">Loading ...</h4>'+
                '</div>';
        },
        wall_menu_update_thread:function($data){
            var $chtml = '';
            var $postId = $data.id;
            var $postLevel = $data.level;
            var $postDate = $data.date;
            var $postLongDate = moment.utc($postDate, 'YYYY-MM-DD HH:mm:ss').local().format('MMMM, DD YYYY hh:mm A');
            var $postType = nlWallHelper.get_post_type($postLevel);
            var $postByLounge = $data.lounge && $data.lounge.key;
            var $postImage = $postByLounge ? $data.lounge.logo_root_lounge : $data.user.profile_image_root_wall;
            var $postImageLink = $postByLounge ? $data.lounge.link : $data.user.profile_url;
            var $postName = $postByLounge ? $data.lounge.name : $data.user.first_name+' '+$data.user.last_name;
            $postName = $postName.length > 75 ? $postName.substr(0, 75) + '...' : $postName;
            var $profileImage = $data.user.my_image_root_wall;
            var $profileImageLink = $data.user.my_profile_url;
            var $postContent = $data.post;
            $postContent = libs.replacePerBreaklines($postContent);
            $postContent = libs.convertUrlToLink($postContent);

            //item, options, post-content
            $chtml += '' +
                '<li class="list-group-item item" data-id="'+$postId+'" data-level="'+$postLevel+'" data-type="'+$postType+'">' +
                '    <div class="row">' +
                '        <div class="col-1 m-0 p-0">' +
                '            <img src="'+$postImage+'" data-link="'+$postImageLink+'" class="img-fluid" alt="profile image">' +
                '        </div>' +
                '        <div class="col-11 m-0 p-0">' +
                '            <div class="container m-0 p-0">' +
                '                <div class="align-self-center w-100">' +
                '                    <div class="float-right p-3">' +
                '                        <a href="javascript:void(0)" class="options with-tooltip" title="Options" data-id="'+$postId+'" data-level="'+$postLevel+'">' +
                '                            <img src="/bimg/NursesLounge/more-horizontal-back.png" alt="option">' +
                '                        </a>' +
                '                    </div>' +
                '                    <h5 class="float-left m-3 font-responsive post-name" data-link="'+$postImageLink+'">'+$postName+'</h5>' +
                '                    <p class="float-right m-3 font-responsive post-date">'+$postLongDate+'</p>' +
                '                </div>' +
                '                <div class="col-12 d-inline-block">' +
                '                    <p class="px-3 pt-3 font-responsive post-content">' +
                $postContent +
                '                    </p>' +
                nlWallHtml.documents($data) +
                nlWallHtml.links($data) +
                nlWallHtml.references($data) +
                '                </div>' +
                '            </div>' +
                nlWallHtml.likes($data) +
                nlWallHtml.reply($data) +
                '        </div>' +
                '    </div>' +
                '</li>';

            return $chtml;
        },
        wall_menu_update_post:function($data){
            var $postId = $data.id;
            var $postLevel = $data.level;
            var $postDate = $data.date;
            var $postLongDate = moment.utc($postDate, 'YYYY-MM-DD HH:mm:ss').local().format('MMMM, DD YYYY hh:mm A');
            var $postType = nlWallHelper.get_post_type($postLevel);
            var $postByLounge = $data.lounge && $data.lounge.key;
            var $postImage = $postByLounge ? $data.lounge.logo_root_lounge : $data.user.profile_image_root_wall;
            var $postImageLink = $postByLounge ? $data.lounge.link : $data.user.profile_url;
            var $postName = $postByLounge ? $data.lounge.name : $data.user.first_name+' '+$data.user.last_name;
            $postName = $postName.length > 75 ? $postName.substr(0, 75) + '...' : $postName;
            var $profileImage = $data.user.my_image_root_wall;
            var $profileImageLink = $data.user.my_profile_url;
            var $postContent = $data.post;
            $postContent = libs.replacePerBreaklines($postContent);
            $postContent = libs.convertUrlToLink($postContent);

            //item, options, post-content
            var $chtml = '';
            $chtml+= '' +
                '<div class="card card-aboutbox card-box mb-4 item" data-id="'+$postId+'" data-level="'+$postLevel+'" data-type="'+$postType+'">' +
                '    <div class="d-flex p-3 border-bottom">' +
                '        <div class="mr-3">' +
                '            <img src="'+$postImage+'" data-link="'+$postImageLink+'" class="post-image" alt="profile image">' +
                '        </div>' +
                '        <div class="align-self-center w-100">' +
                '            <h4 class="float-left m-3 font-responsive post-name" data-link="'+$postImageLink+'">'+$postName+'</h4>' +
                '            <p class="float-right m-3 font-responsive post-date" data-id="'+$postId+'" data-postdate="'+$postDate+'" data-postlongdate="'+$postLongDate+'">'+$postLongDate+'</p>' +
                '        </div>' +
                '        <div class="align-self-center">' +
                '            <a href="javascript:void(0)" class="options with-tooltip" title="Options" data-id="'+$postId+'" data-level="'+$postLevel+'">' +
                '                <img src="/bimg/NursesLounge/more-horizontal-back.png" alt="option">' +
                '            </a>' +
                '        </div>' +
                '    </div>' +
                '    <div class="card-body px-0">' +
                '        <div>' +
                '            <p class="px-3 pt-3 font-responsive post-content">' +
                $postContent +
                '            </p>' +
                nlWallHtml.documents($data) +
                nlWallHtml.links($data) +
                nlWallHtml.references($data) +
                nlWallHtml.likes($data) +
                nlWallHtml.reply($data) +
                '           <div class="comments" data-id="'+$postId+'"></div>'+
                '           <div class="row thread">' +
                '               <a href="javascript:void(0)" class="open-thread w-100 text-center with-tooltip" title="... Read more" data-parent_id="0" data-id="'+$postId+'" data-level="'+$postLevel+'">' +
                '                   ... Read more' +
                '               </a>' +
                '           </div>' +
                '       </div>' +
                '    </div>' +
                '</div>';

            return $chtml;
        }
    };
    var nlWallEvents ={
        comments:function($options){
            $options.wall_container().find('.item').each(function(){
                var $that = $(this);
                var $id = $that.data('id');
                nlWall.post_send({
                    first_wall_post:0,
                    level:0,
                    rows:5, //How many rows will load at the beginning (wall_get_step) 10
                    post_step:2, //$wallShowPost step (wall_post_get_step)
                    comment_step:2, //$wallShowComments step (wall_comment_get_step)
                    subcomment_step:2, //$wallShowSubComments step (wall_sub_comment_get_step),
                    wall_container:function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left .wall-container");
                    },
                    wall_container_btn:function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left .btn-refresh-wall-up");
                    },
                    wall_share_modal:function(){
                        return $("#nurseslounge-home-activity-wall-share-modal");
                    },
                    wall_textarea:function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.post-text[data-id="'+$id+'"]');
                    },
                    wall_send_btn:function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.send-post[data-id="'+$id+'"]');
                    },
                    wall_attach_preview:function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.preview[data-id="'+$id+'"]');
                    }
                }, function(){
                    nlWallRecognizeUrl.init({
                        wall_textarea: function(){
                            return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.post-text[data-id="'+$id+'"]');
                        },
                        recognize_url_preload_target: function(){
                            return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.preview[data-id="'+$id+'"]');
                        },
                        recognize_url_target: function(){
                            return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.preview[data-id="'+$id+'"]');
                        },
                        on_key_press_callback: false
                    }, function () {
                        nlWallUpdate.init({
                            wall_update_button:function(){
                                return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.upload[data-id="'+$id+'"]');
                            },
                            wall_update_preload_target: function(){
                                return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.preview[data-id="'+$id+'"]');
                            },
                            wall_update_target: function(){
                                return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.preview[data-id="'+$id+'"]');
                            },
                            wall_update_text_area:function(){
                                return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.post-text[data-id="'+$id+'"]');
                            },
                            on_close_modal_callback:false,
                            on_end_callback:false,
                            get_data_callback:false,
                            wall_update_skip:[]
                        }, function(){
                            libs.checkImageLoad($('body').find('img'), function(){
                                libs.refreshTooltips();
                            });
                        });
                    });
                });
            });
        }
    };
    $.fn.nurseslounge_myDashboard_wall = function(
        $params,
        $nlWallOptions,
        $nlWallRecognizeUrlOptions,
        $nlWallUpdateOptions,
        $nlWallAlbumOptions,
        $nlWallDocumentPreviewOptions,
        $nlWallMenuOptions,
        $notRun
    ){
        if($notRun == undefined){
            $notRun == false;
        }

        nlWallHelper.set_with_params($params);
        //nlWall
        var $nlWallDefaults = {
            wall_url_get:"/myDashboard/activity/wall/get",
            wall_url_likes:"/myDashboard/activity/wallLikes/set",
            wall_url_share_get:"/myDashboard/activity/wallOptionsMenuShare/get",
            wall_url_share_set:"/myDashboard/activity/wallOptionsMenuShare/set",
            wall_url_set:"/myDashboard/activity/wall/set",
            wall_debug:false
        };
        if($nlWallOptions != undefined){
            $nlWallSettings = $.extend({}, $nlWallDefaults, $nlWallOptions);
        }else{
            $nlWallSettings = $.extend({}, $nlWallDefaults);
        }
        nlWall =  {
            init:function($options){
                $options = $options == undefined ? {} : $options;
                $options = $.extend({}, {
                    first_wall_post:0,
                    level:0,
                    rows:5, //How many rows will load at the beginning (wall_get_step) 10
                    post_step:2, //$wallShowPost step (wall_post_get_step)
                    comment_step:2, //$wallShowComments step (wall_comment_get_step)
                    subcomment_step:2, //$wallShowSubComments step (wall_sub_comment_get_step),
                    wall_container:function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left .wall-container");
                    },
                    wall_container_btn:function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left .btn-refresh-wall-up");
                    },
                    wall_share_modal:function(){
                        return $("#nurseslounge-home-activity-wall-share-modal");
                    },
                    wall_textarea:function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.post-text[data-id="0"]');
                    },
                    wall_send_btn:function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.send-post[data-id="0"]');
                    },
                    wall_attach_preview:function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.preview[data-id="0"]');
                    },
                    wall_open_album:function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-right").find('.album:first');
                    },
                }, $options);
                var $rows = $options.rows;
                var $firstWallPost = $options.first_wall_post;
                var $level = $options.level;
                nlWall.get({
                        first_wall_post:$firstWallPost,
                        show:'down',
                        limit:$rows,
                        offset:0,
                        level:$level
                    },
                    $options,
                    function(){
                        nlWallEvents.comments($options);
                    });
                $options.wall_open_album().find('.option').each(function(){
                    var $that = $(this);
                    if($that.data('action') == 'open'){
                        $that.unbind().click(function(){
                            nlWallAlbum.open({
                                on_close_modal:false,
                                on_end_callback:false,
                                on_start_callback:false,
                                album_allow_tabs : {
                                    'profile_webcam_image':true,
                                    'profile_image':true,
                                    'profile_document':true,
                                    'profile_video':true,
                                    'profile_article':true
                                },
                                album_step:11,
                                album_allow_add:true,
                                album_allow_select:false
                            });
                        });
                    }
                });
            },
            get:function($params, $options, cback){
                var $wallUrlGet = $nlWallSettings.wall_url_get;
                var $wallDebug = $nlWallSettings.wall_debug;
                var $withParams = $.extend({}, nlWallHelper.get_with_params(), $params);
                $.ajax({
                    url:$wallUrlGet,
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data: $withParams,
                    success: function ($data, $status, $response) {
                        libs.expire($data);
                        if($wallDebug){console.log($withParams);console.log($wallUrlGet);console.log($data);}
                        if($data.status == 'success'){
                            nlWall.refresh($data.data.wall_post, 0, $options, function(){
                                nlWall.clock($options, function(){
                                    nlWall.fade_in($options, function(){
                                        nlWall.load_more($data.data.total_filtered, $options,function() {
                                            if (cback != undefined) {
                                                cback();
                                            }
                                        });
                                    });
                                });
                            });
                        }
                    }
                });
            },
            refresh:function($wallPost, $postIndex, $options, cback){
                $wallPost = Object.values($wallPost);
                var $wallContainer = $options.wall_container();
                var $wallDebug = $nlWallSettings.wall_debug;
                var $existId = [];
                var $data = $wallPost[$postIndex];
                if($data != undefined) {
                    var $id = $data.id;
                    var $level = $data.level;
                    var $comments = $data.comments;
                    var $postType = nlWallHelper.get_post_type($level);
                    $wallContainer.find('.item').each(function(){
                        if($(this).data('id') != undefined){
                            if($(this).data('type') == $postType){
                                $existId.push($(this).data('id'));
                            }
                        }
                    });
                    if($wallDebug){
                        console.log("Render ");
                        console.log("id "+$id);
                        console.log("level "+$level);
                    }
                    if ($.inArray($id, $existId) == -1) {
                        if ($level == 0) {
                            nlWall.post($existId, $wallPost, $postIndex, $options, cback);
                        }else{
                            nlWall.thread($existId, $wallPost, $postIndex, $options, cback);
                        }
                    }else{
                        nlWall.refresh($comments, 0, $options, cback);
                    }
                }else{
                    if(cback != undefined){
                        cback();
                    }
                }
            },
            post:function($postId, $wallPost, $postIndex, $options, cback){
                var $data = $wallPost[$postIndex];
                var $comments = $data.comments;
                var $commentsCount = $data.comments_count;
                var $id = $data.id;
                var $wallContainer = $options.wall_container();
                var $postElement = [];
                var $wallDebug = $nlWallSettings.wall_debug;
                $wallContainer.find('.item').each(function(){
                    if($(this).data('id') != undefined){
                        if($(this).data('type') == 'post') {
                            $postElement.push($(this));
                        }
                    }
                });
                if($postId.length == 0){
                    if($wallDebug){console.log("level 0 html 0 "+$commentsCount);}
                    $options.wall_container().html(nlWallHtml.post($data)).promise().done(function(){
                        nlWall.refresh($comments, 0, $options, function(){
                            nlWall.refresh($wallPost, ($postIndex+1), $options, cback);
                        });
                    });
                }else
                if($postId.length == 1){
                    if($id > $postId[0]){
                        if($wallDebug){console.log("level 0 prepend 1 "+$commentsCount);}
                        $options.wall_container().prepend(nlWallHtml.post($data)).ready(function(){
                            nlWall.refresh($comments, 0, $options, function() {
                                nlWall.refresh($wallPost, ($postIndex + 1), $options, cback);
                            });
                        });
                    }else{
                        if($wallDebug){console.log("level 0 append 1 "+$commentsCount);}
                        $options.wall_container().append(nlWallHtml.post($data)).ready(function(){
                            nlWall.refresh($comments, 0, $options, function() {
                                nlWall.refresh($wallPost, ($postIndex + 1), $options, cback);
                            });
                        });
                    }
                }else
                if($postId.length > 1){
                    if($postId[$postId.length - 1] > $id){
                        if($wallDebug){console.log("level 0 append >1 "+$commentsCount);}
                        $options.wall_container().append(nlWallHtml.post($data)).ready(function(){
                            nlWall.refresh($comments, 0, $options, function() {
                                nlWall.refresh($wallPost, ($postIndex + 1), $options, cback);
                            });
                        });
                    }else
                    if($postId[0] < $id){
                        if($wallDebug){console.log("level 0 prepend >1 "+$commentsCount);}
                        $options.wall_container().prepend(nlWallHtml.post($data)).ready(function(){
                            nlWall.refresh($comments, 0, $options, function() {
                                nlWall.refresh($wallPost, ($postIndex + 1), $options, cback);
                            });
                        });
                    }else{
                        if($wallDebug){console.log("level 0 after >1 "+$commentsCount);}
                        $.each($postId, function($index){
                            if($postId[$index+1] != undefined){
                                if($postId[$index] > $id && $id > $postId[$index+1]){
                                    $postElement[$index].after(nlWallHtml.post($data)).ready(function(){
                                        nlWall.refresh($comments, 0, $options, function() {
                                            nlWall.refresh($wallPost, ($postIndex + 1), $options, cback);
                                        });
                                        return false;
                                    });
                                }
                            }
                        });
                    }
                }
            },
            thread:function($postId, $wallPost, $postIndex, $options, cback){
                var $data = $wallPost[$postIndex];
                var $id = $data.id;
                var $parentId = $data.parent_id;
                var $dataComments = $data.comments;
                var $level = $data.level;
                var $postLength = $wallPost.length;
                var $wallContainer = $options.wall_container();
                var $wallDebug = $nlWallSettings.wall_debug;
                var $post = $wallContainer.find('.item[data-id="'+$parentId+'"]');
                var $href = $wallContainer.find('.open-thread[data-id="'+$parentId+'"]');
                var $comments = $wallContainer.find('.comments[data-id="'+$parentId+'"] ul:first');
                var $postType = nlWallHelper.get_post_type($level);
                var $items = $comments.find('> li.item');
                var $showing = parseInt(nlWallHelper.get_visibles_in($postType, $items));
                $comments.append(nlWallHtml.thread($data)).ready(function(){
                    $wallContainer = $options.wall_container();
                    $post = $wallContainer.find('.item[data-id="'+$parentId+'"]');
                    $href = $wallContainer.find('.open-thread[data-id="'+$parentId+'"]');
                    $comments = $wallContainer.find('.comments[data-id="'+$parentId+'"] ul:first');
                    $items = $comments.find('> li.item');
                    $showing = parseInt(nlWallHelper.get_visibles_in($postType, $items));
                    if($wallDebug){
                        console.log("Subrender ");
                        console.log("id "+$id);
                        console.log("level "+$level);
                        console.log('show '+$showing);
                        console.log('length '+$postLength);
                    }
                    if($showing < $postLength){
                        $href.show();
                    }else{
                        $href.hide();
                    }
                    nlWall.refresh($dataComments, 0, $options, function(){
                        nlWall.refresh($wallPost, ($postIndex+1), $options, cback);
                    });
                });
            },
            clock:function($options, cback){
                var $wallContainer = $options.wall_container();
                var $postIds = [];
                $wallContainer.find(".item .post-date").each(function(){
                    var $that = $(this);
                    $postIds.push($that.data('id'));
                });
                nlWallHelper.set_wall_dates($postIds);
                nlWallHelper.wall_date(function(){
                    if(cback != undefined){
                        cback();
                    }
                });
            },
            fade_in:function($options, cback){
                var $wallContainer = $options.wall_container();
                $wallContainer.find(".item").each(function(){
                    var $item = $(this);
                    libs.checkImageLoad($item.find('img'), function(){
                        $item.css('display','block');
                    });
                });
                if(cback != undefined){
                    cback();
                }
            },
            load_more:function($totalFiltered, $options, cback) {
                var $wallDebug = $nlWallSettings.wall_debug;
                var $postStep = $options.post_step;
                var $commentStep = $options.comment_step;
                var $subcommentStep = $options.subcomment_step;
                var $wallContainer = $options.wall_container();
                var $wallContainerBtn = $options.wall_container_btn();
                if ($wallDebug) {
                    console.log("load more - loaded");
                }
                var $items = $wallContainer.find('.item');
                var $firstWallPostId = $wallContainer.find('.item:first').data('id');
                var $lastItem = $wallContainer.find('div[data-level="0"]:last');
                var $totalPost = parseInt(nlWallHelper.get_visibles_in('post', $items));
                var $wallLoadMore = $options.wall_container().find('.btn-load-more-container');
                //Load More Down
                $wallLoadMore.remove();
                if ($totalFiltered > $totalPost) {
                    $lastItem.after(nlWallHtml.load_more()).ready(function () {
                        $wallLoadMore = $options.wall_container().find('.btn-load-more-container');
                        $wallLoadMore.unbind().click(function () {
                            nlWall.get({
                                first_wall_post: $firstWallPostId,
                                show: 'down',
                                limit: $postStep,
                                offset: $totalPost,
                                level: 0
                            }, $options);
                        });
                    });
                }
                //Load More Up
                $wallContainerBtn.unbind().click(function () {
                    var $that = $(this);
                    $that.fadeOut("slow", function () {
                        nlWall.get({
                            first_wall_post: $firstWallPostId,
                            show: 'up',
                            limit: 0,
                            offset: 0,
                            level: 0
                        }, $options, function () {
                            if(!$notRun) {
                                nlWall.init();
                            }
                        });
                    });
                });
                $wallContainerBtn.fadeIn();
                //Load More Comments
                $wallContainer.find(".open-thread").unbind().click(function () {
                    $(window).off('scroll');
                    var $id = $(this).data('id');
                    var $level = $(this).data('level');
                    $level = ($level + 1);
                    var $comments = $wallContainer.find('.comments[data-id="' + $id + '"] ul:first > li.item');
                    var $postType = nlWallHelper.get_post_type($level);
                    var $totalComments = parseInt(nlWallHelper.get_visibles_in($postType, $comments));
                    var $limit = 0;
                    if ($postType == 'comment') {
                        $limit = $commentStep;
                    }
                    if ($postType == 'sub-comment') {
                        $limit = $subcommentStep;
                    }
                    nlWall.get({
                        first_wall_post: $id,
                        show: 'down',
                        limit: $limit,
                        offset: $totalComments,
                        level: $level
                    }, $options, function () {
                        nlWallEvents.comments($options);
                    });
                });
                $wallContainer.find('.open-thread').each(function ($i, $v) {
                    var $that = $(this);
                    var $id = $that.data('id');
                    var $level = $(this).data('level');
                    $level = ($level + 1);
                    var $count = $wallContainer.find('.comments-count[data-id="' + $id + '"]').data('count');
                    var $comments = $wallContainer.find('.comments[data-id="' + $id + '"] ul:first > li.item');
                    var $postType = nlWallHelper.get_post_type($level);
                    var $totalComments = parseInt(nlWallHelper.get_visibles_in($postType, $comments));
                    if ($count > $totalComments) {
                        $that.show();
                    } else {
                        $that.hide();
                    }
                });
                //Reply Post
                $wallContainer.find(".reply-post").unbind().click(function () {
                    $wallContainer.find('ul > li .reply').hide();
                    var $that = $(this);
                    var $id = $that.data('id');
                    var $reply = $wallContainer.find('.reply[data-id="' + $id + '"]');
                    $reply.show();
                    $reply.find('.reply-post textarea').focus();
                });
                //Comments Focus
                $wallContainer.find(".comments-focus").unbind().click(function () {
                    $wallContainer.find('.comments').css('border', '0px');
                    var $that = $(this);
                    var $id = $that.data('id');
                    var $focus = $options.wall_container().find('.comments[data-id="' + $id + '"]');
                    var $openThread = $options.wall_container().find('.open-thread[data-id="' + $id + '"]');
                    var $haveComments = $focus.find('.item').length > 0;
                    if($haveComments || $openThread.is(':visible')){
                        $focus.css('border', 'solid 5px #00000038');
                        var $offsetTop = $wallContainer.find('.item[data-id="' + $id + '"]').offset().top;
                        $(window).animate({ scrollTop: $offsetTop });
                        if($openThread.is(':visible')){
                            $openThread.click();
                        }
                        setTimeout(function () {
                            $wallContainer.find('.comments').css('border', '0px');
                        }, 6000);
                    }
                });
                //Wall Options
                $wallContainer.find(".options").unbind().click(function () {
                    var $that = $(this);
                    var $id = $that.data('id');
                    var $level = $that.data('level');
                    nlWallMenu.init($id, $level);
                });
                //Wall Likes
                $wallContainer.find('.add-like').unbind().click(function () {
                    var $id = $(this).data('id');
                    nlWall.likes($id, function ($data) {
                        var $ele = $wallContainer.find('.add-like[data-id="' + $id + '"] i');
                        var $countEle = $wallContainer.find('.likes-count[data-id="' + $id + '"]');
                        if ($data.data.action == 'added') {
                            $ele.removeClass('fa-heart-o').addClass('fa-heart');
                            $countEle.html($data.data.likes_count);
                        }
                        if ($data.data.action == 'deleted') {
                            $ele.effect('shake', {
                                direction: 'left',
                                distance: '3',
                                times: '4'
                            }, 400, function () {
                                $ele.removeClass('fa-heart').addClass('fa-heart-o');
                                $countEle.html($data.data.likes_count);
                            });
                        }
                    });
                });
                //Wall Preview
                var $players = [];
                $wallContainer.find('.attach').each(function () {
                    var $that = $(this);
                    var $id = $that.data('id');
                    var $type = $that.data('type');
                    var $url = $that.data('url');
                    var $fileType = $that.data('filetype');
                    var $loungeKey = $that.data('loungekey');
                    var $loungeWallKey = $that.data('loungewallkey');
                    var $document = libs.memoryGet($fileType + $id);
                    var $documentId = $document.id;
                    if ($type == 'website-document' && $fileType) {
                        libs.memorySave($fileType + $id, $.extend(libs.memoryGet($fileType + $id), {that: $that}));
                        if ($fileType == 'video') {
                            $players.push($id);
                        }else{
                            $that.unbind().click(function () {
                                nlWallDocumentPreview.init($documentId);
                            });
                        }
                    }
                    if ($type == 'website-thumb' && $fileType == 'link') {
                        $that.unbind().click(function () {
                            window.open($url, '_blank', '');
                        });
                    }
                    if ($type == 'website-reference' && !$fileType) {
                        $that.unbind().click(function () {
                            window.open('/lounge/'+$loungeKey+'/activity/notification/fromWall/loungeWall/'+$loungeWallKey, '_self', '');
                        });
                    }
                });
                //Wall Scroll Load More & Video Player
                var $scrollBinding;
                var $scrollLoadWallBinding;
                $(window).off('scroll').scroll(function () {
                    //Load More
                    var $loadMoreAfterPercent = 30;
                    var $maxScrollTop = $(document).height() - $(window).height();
                    var $actualScroll = $(window).scrollTop();
                    var $triggerPercent = ($actualScroll * 100) / $maxScrollTop > $loadMoreAfterPercent;
                    if ($triggerPercent && $options.wall_container().find('.btn-load-more-container').is(':visible')) {
                        try {
                            clearTimeout($scrollLoadWallBinding);
                        } catch (e) {
                        }
                        $scrollLoadWallBinding = setTimeout(function () {
                            $options.wall_container().find('.btn-load-more-container').click();
                        }, 200);
                    }
                    //Video Player
                    var $wH = $(window).height();
                    var $margin = ($wH / 3);
                    try {
                        clearTimeout($scrollBinding);
                    } catch (e) {
                    }
                    $scrollBinding = setTimeout(function () {
                        //Video
                        $.each($players, function ($i, $v) {
                            var $that = $options.wall_container().find('.attach[data-id="' + $v + '"]');
                            if ($that.length > 0) {
                                var $originalHtml = $that[0].outerHTML;
                                var $player = libs.memoryGet('player' + $v) ? libs.memoryGet('player' + $v) : false;
                                var $y = $that.offset().top - $(window).scrollTop();
                                var $video = libs.memoryGet('video' + $v);
                                if (($y + $margin) < ($wH + $margin)  && ($y + $margin) > (-1 * $margin) && $that.height() > 0 && $that.width() > 0) {
                                    if(!$player) {
                                        $that.height(300);
                                        try {
                                            $player = new Artplayer({
                                                destroy: true,
                                                container: $that[0],
                                                title: $video.name,
                                                url: $video.document_preview_root + '?temporal=true',
                                                poster: $video.document_thumb_root,
                                                type: 'mp4',
                                                mutex: true,
                                                muted: true,
                                                play: false,
                                                pause: true,
                                                toggle: false,
                                                controls: [
                                                    {
                                                        position: 'right',
                                                        html: 'Fullscreen',
                                                        click: function () {
                                                            nlWallDocumentPreview.init($video.id);
                                                        },
                                                    },
                                                ],
                                                miniProgressBar: true,
                                                loop: true,
                                                fullscreen: false,
                                                fullscreenToggle: false,
                                                fullscreenWeb: false,
                                                fullscreenWebToggle: false,
                                                fullscreenRotate: false,
                                                fullscreenRotateToggle: false,
                                                moreVideoAttr: {
                                                    crossOrigin: 'anonymous',
                                                    playsInline: true,
                                                    'webkit-playsinline': true,
                                                    'x5-video-player-type': 'h5',
                                                    'x5-video-player-fullscreen': false,
                                                    'x5-video-orientation': 'portraint',
                                                },
                                                whitelist: ['*']
                                            }).on('destroy', function () {
                                                $that.replaceWith($originalHtml);
                                                libs.refreshTooltips();
                                            }).on('ready', function () {
                                                if(($y + $margin) < $wH  && ($y + $margin) > 0){
                                                    $player.player.play = true;
                                                }else{
                                                    $player.player.pause = true;
                                                }
                                                libs.refreshTooltips();
                                            });
                                            $player.mask.show = false;
                                            libs.memorySave('player' + $v, $player);
                                        } catch ($e) {

                                        }
                                    }
                                    if(($y + $margin) < $wH  && ($y + $margin) > 0){
                                        $player.player.play = true;
                                    }else{
                                        $player.player.pause = true;
                                    }
                                } else {
                                    if ($player) {
                                        try{
                                            $player.player.pause = true;
                                        }catch($e){
                                            libs.memorySave('player' + $v, false);
                                        }
                                    }
                                }
                            }
                        });
                    }, 600);
                });
                //Wall Share
                $wallContainer.find(".share-with").unbind().click(function () {
                    var $id = $(this).data('id');
                    var $chtml = '';
                    var $wallShareModal = $options.wall_share_modal();
                    var $modalInfo = $wallShareModal.find('.modal-info:first');
                    nlWall.share_get($id, function ($data) {
                        var $wallPost = $data.data.wall_post;
                        if ($.inArray('facebook', $data.data.options) != -1) {
                            $chtml += '<li class="nav-item with-tooltip" title="Facebook"><a class="nav-link" data-action="facebook" href="javascript:void(0)"><i class="fa fa-facebook social-icons facebook-color"></i></a></li>';
                        }
                        if ($.inArray('twitter', $data.data.options) != -1) {
                            $chtml += '<li class="nav-item with-tooltip" title="Twitter"><a class="nav-link" data-action="twitter" href="javascript:void(0)"><i class="fa fa-twitter social-icons twitter-color"></i></a></li>';
                        }
                        if ($.inArray('pinterest', $data.data.options) != -1) {
                            $chtml += '<li class="nav-item with-tooltip" title="Pinterest"><a class="nav-link" data-action="pinterest" href="javascript:void(0)"><i class="fa fa-pinterest-p social-icons pint-color"></i></a></li>';
                        }
                        if ($.inArray('linkedin', $data.data.options) != -1) {
                            $chtml += '<li class="nav-item with-tooltip" title="Linkedin"><a class="nav-link" data-action="linkedin" href="javascript:void(0)"><i class="fa fa-linkedin social-icons linkedin-color"></i></a></li>';
                        }
                        $wallShareModal.find('.share-options:first').html($chtml).promise().done(function () {
                            var $shareLink = encodeURIComponent($wallPost.share_link);
                            var $url = encodeURIComponent(window.location.href);
                            var $post = encodeURIComponent($wallPost.post);
                            var $image = '';
                            if (libs.isEmptyReturnNull($wallPost.documents) &&
                                libs.isEmptyReturnNull($wallPost.documents[0]) &&
                                libs.isEmptyReturnNull($wallPost.documents[0].document) &&
                                libs.isEmptyReturnNull($wallPost.documents[0].document.document_thumb_root)) {
                                $image = encodeURIComponent($wallPost.documents[0].document.document_thumb_root);
                            }
                            var $features = '';
                            $(this).find('.nav-link').unbind().click(function () {
                                var $action = $(this).data('action');
                                nlWall.share_set($id, $options, function () {
                                    switch ($action) {
                                        case 'facebook':
                                            window.open('https://www.facebook.com/sharer/sharer.php?u=' + $shareLink, '_blank', $features);
                                            break;
                                        case 'twitter':
                                            window.open('https://twitter.com/intent/tweet?url=' + $shareLink + '&text=' + $post, '_blank', $features);
                                            break;
                                        case 'pinterest':
                                            window.open('http://www.pinterest.com/pin/create/button?url=' + $url + '&media=' + $image + '&description=' + $post, '_blank', $features);
                                            break;
                                        case 'linkedin':
                                            window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + $shareLink, '_blank', $features);
                                            break;
                                    }
                                });
                            });
                        });
                        var $chtmlInfo = nlWallHtml.wall_menu_popup($wallPost, [], 'readonly');
                        $modalInfo.html(nlWallHtml.wall_menu_preload()).promise().done(function () {
                            libs.checkImageLoad($($chtmlInfo).find('img'), function () {
                                $modalInfo.html($chtmlInfo).promise().done(function(){
                                    libs.refreshTooltips();
                                });
                            });
                        });
                        $wallShareModal.modal('show');
                    });
                });
                //Wall Links
                $wallContainer.find('[data-link]').unbind().click(function() {
                    var $that = $(this);
                    var $link = $that.data('link');
                    router.navigate($link,true);
                });
                //Wall Post
                nlWall.post_send($options, function () {
                    nlWallRecognizeUrl.init({}, function () {
                        nlWallUpdate.init({}, function () {
                            cback();
                        });
                    });
                });
                //Wall Post Empty
                if($wallContainer.html() == ''){
                    libs.render("/myDashboard", 'nurseslounge_myDashboard', 'activity', {}, 'POST');
                    //nlWall.isEmpty($options);
                }
            },
            isEmpty:function($options){
                var $chtml = '';
                var $params = {user_id:libs.memoryGet('user_id')};
                var $wallContainer = $options.wall_container();
                nurseslounge_myDashboard_myProfile.task_list_request($params, function($data){
                    var  $taskList = $data && $data.data && $data.data.task_list;
                    $taskList = $taskList.filter(function($v,$i) {
                        return !$v['status'];
                    });
                    $taskList = $taskList.map(function($v,$i) {
                        return $v['id'];
                    });
                    $chtml = '' +
                        '<div class="col-12">' +
                        '    <div class="card card-aboutbox card-box mb-4">' +
                        '        <div class="card-body m-3 p-2">' +
                        '            <h5 class="text-center">' +
                        '               No posts to your bulletin board yet. Check back soon!' +
                        '            </h5>' +
                        '            <h5 class="text-center">' +
                        '               Bulletin boards block out unnecessary noise and help deliver relevant career content. As jobs, hiring incentives, events, and other posts arrive we\'ll share them on your bulletin board.' +
                        '            </h5>' +
                        '            <h5 class="text-center">' +
                        '               If you want a more expansive scope of content here are some things you can do.' +
                        '            </h5>' +
                        '            <h5 class="mt-5">' +
                        '               <ul class="list-items">' +
                        '                   <li>' +
                        '                       <a href="/lounges/schools" target="_self" class="link-color">Follow Lounges</a>: We\'ll prioritize their posts on your bulletin board.' +
                        '                   </li>';
                    if($.inArray(1, $taskList) > -1){ //Complete My Profile
                        $chtml +=
                            '<li>' +
                            '   <a href="javascript:void(0)" target="_self" class="link-color complete-profile">Complete Profile</a>: Your profile is private. The more complete your profile is the more accurate and relevant posts become on your bulletin board.' +
                            '</li>';
                    }
                    $chtml +=
                        '                   <li>' +
                        '                       <a href="javascript:void(0)" target="_self" class="link-color invite-someone">Invite Someone</a>: Help us grow. As more nurses create dashboards organizations become more encouraged to participate.' +
                        '                   </li>' +
                        '               </ul>' +
                        '            </h5>' +
                        '        </div>' +
                        '    </div>' +
                        '</div>';
                    $wallContainer.html($chtml).promise().done(function(){
                        var $completeProfile = $wallContainer.find('.complete-profile');
                        var $inviteSomeone = $wallContainer.find('.invite-someone');
                        $completeProfile.unbind().click(function(){
                            nurseslounge_myDashboard_myProfile.user_profile_fill($params, false);
                        });
                        $inviteSomeone.unbind().click(function(){
                            nurseslounge_myDashboard_myProfile.invite_colleagues_modal();
                        });
                    });
                });
            },
            likes:function($id, cback){
                var $wallUrlLikes = $nlWallSettings.wall_url_likes;
                var $wallDebug = $nlWallSettings.wall_debug;
                var $withParams = $.extend({}, nlWallHelper.get_with_params(), {wall_id:$id});
                $.ajax({
                    url:$wallUrlLikes,
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data:$withParams,
                    success: function ($data) {
                        libs.expire($data);
                        if($data.status == 'success'){
                            if($wallDebug){console.log($withParams);console.log($wallUrlLikes);console.log($data);}
                            cback($data);
                        }
                    }
                });
            },
            share_get:function($id, cback){
                var $wallUrlShareGet = $nlWallSettings.wall_url_share_get;
                var $wallDebug = $nlWallSettings.wall_debug;
                var $withParams = $.extend({}, nlWallHelper.get_with_params(), {id:$id});
                $.ajax({
                    url: $wallUrlShareGet,
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data:$withParams,
                    success: function ($data) {
                        libs.expire($data);
                        if($data.status == 'success'){
                            if($wallDebug){console.log($withParams);console.log($wallUrlShareGet);console.log($data);}
                            cback($data);
                        }
                    }
                });
            },
            share_set:function($id, $options, cback){
                var $wallUrlShareSet = $nlWallSettings.wall_url_share_set;
                var $wallDebug = $nlWallSettings.wall_debug;
                var $withParams = $.extend({}, nlWallHelper.get_with_params(), {id:$id});
                $.ajax({
                    url:$wallUrlShareSet,
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data:$withParams,
                    success: function ($data) {
                        libs.expire($data);
                        if($wallDebug){console.log($withParams);console.log($wallUrlShareSet);console.log($data);}
                        if($data.status == 'success'){
                            cback($data);
                        }
                        if($data.status == 'error'){
                            $options.wall_share_modal().modal('hide');
                        }
                    }
                });
            },
            post_send:function($options, cback){
                var $wallSendBtn = $options.wall_send_btn();
                libs.memorySave('prevent_load_post_binding', 0);
                $wallSendBtn.unbind().click(function(){
                    var $that = $(this);
                    var $id = $that.data('id');
                    var $toUserId = $that.data('touserid');
                    var $level = $that.data('level');
                    var $post = $options.wall_textarea().val();
                    var $urls = [];
                    var $documents = [];
                    $options.wall_attach_preview().find('.attach').each(function () {
                        var $that = $(this);
                        if ($that.data('type') == 'website-thumb') {
                            $urls.push($that.data('url'));
                        }
                        if ($that.data('type') == 'website-document') {
                            $documents.push($that.data('id'));
                        }
                    });
                    if($post != '') {
                        nlWall.set($toUserId, $post, $id, $urls, $documents, function ($data) {
                            $options.wall_textarea().val('');
                            $options.wall_attach_preview().html('');
                            var $wallContainer = $options.wall_container();
                            $level = ($level+1);
                            var $postType = nlWallHelper.get_post_type($level);
                            var $totalComments = 0;
                            var $parentId = $data.data.parent_id;
                            var $commentsTotal = $data.data.total;
                            var $commentsCountEle = $wallContainer.find('.comments-count[data-id="'+$id+'"]');
                            $commentsCountEle.html($commentsTotal);
                            $commentsCountEle.attr('data-count', $commentsTotal);
                            var $comments = $wallContainer.find('.comments[data-id="'+$id+'"] ul:first > li.item');
                            $totalComments = parseInt(nlWallHelper.get_visibles_in($postType, $comments));
                            nlWall.get({
                                first_wall_post:$parentId == 0 ? 0 : $id,
                                show:$parentId == 0 ? 'up' : 'down',
                                limit:0,
                                offset:$parentId == 0 ? 0 : $totalComments,
                                level:$parentId == 0 ? 0 : $level
                            }, $options, function(){
                                nlWallEvents.comments($options);
                            });
                        });
                    }else{
                        alert("Please write something");
                    }
                });
                if(cback != undefined){
                    cback();
                }
            },
            set:function($toUserId, $post, $parentId, $urls, $documents, cback){
                var $wallUrlSet = $nlWallSettings.wall_url_set;
                var $wallDebug = $nlWallSettings.wall_debug;
                var $withParams = $.extend({}, nlWallHelper.get_with_params(), {to_user_id:$toUserId, post:$post, parent_id:$parentId, urls: $urls, documents:$documents});
                $.ajax({
                    url: $wallUrlSet,
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data:$withParams,
                    success: function ($data) {
                        libs.expire($data);
                        if($data.status == 'success'){
                            if($wallDebug){console.log($withParams);console.log($wallUrlSet);console.log($data);}
                            cback($data);
                        }
                    }
                });
            }
        };

        //nlWallRecognizeUrl
        var $nlWallRecognizeUrlDefaults = {
            recognize_url_url:"/myDashboard/activity/wallRecognize/get",
        };
        if($nlWallRecognizeUrlOptions != undefined){
            $nlWallRecognizeUrlSettings = $.extend({}, $nlWallRecognizeUrlDefaults, $nlWallRecognizeUrlOptions);
        }else{
            $nlWallRecognizeUrlSettings = $.extend({}, $nlWallRecognizeUrlDefaults);
        }
        $nlWallRecognizeUrlOriginal = $nlWallRecognizeUrlDefaults;
        nlWallRecognizeUrl = {
            regex:function(){
                return {
                    pattern:'(http(s?):\\/\\/)(w{3}\\.)?([^: \\/\\n]+).([a-z]{2,63})([^\\s]{1,})?',
                    flags:'gi'
                };
            },
            init:function($options, cback){
                $options = $options == undefined ? {} : $options;
                $options = $.extend({}, {
                    wall_textarea: function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.post-text[data-id="0"]');
                    },
                    recognize_url_preload_target: function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.preview[data-id="0"]');
                    },
                    recognize_url_target: function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.preview[data-id="0"]');
                    },
                    on_key_press_callback: false
                }, $options);
                var $regex = this.regex();
                var $url = new RegExp($regex.pattern, $regex.flags);
                var $searchGlobal = [];
                var $searchBinding;
                var $skipFromSearchGlobal = [];
                var $wallTextArea = $options.wall_textarea();
                var $onKeyPressCallback = $options.on_key_press_callback;
                var $recognizeUrlPreloadTarget = $options.recognize_url_preload_target();
                var $recognizeUrlPreloadHtml = nlWallHtml.recognize_preload();
                var $recognizeUrlTarget = $options.recognize_url_target();
                $wallTextArea.unbind().on('keypress keyup keydown blur', function(){
                    if($onKeyPressCallback){
                        $onKeyPressCallback();
                    }
                    libs.memorySave('prevent_load_post_binding', 1);
                    var $text = $(this).val();
                    var $matches = $text.match($url);
                    var $search = false;
                    try {
                        clearTimeout($searchBinding);
                    }catch (e) {

                    }
                    if($text == ''){
                        $searchGlobal = [];
                        $skipFromSearchGlobal = [];
                    }
                    $searchBinding = setTimeout(function(){
                        if($matches) {
                            $matches = $matches.filter(function($el){
                                return !$skipFromSearchGlobal.includes($el);
                            });
                            $.each($matches, function ($i, $v) {
                                if ($.inArray($v, $searchGlobal) == -1) {
                                    $search = true;
                                    return false;
                                }
                            });
                        }
                        if ($search) {
                            if(libs.memoryGet('prevent_load_post_binding')){
                                $recognizeUrlPreloadTarget.html($recognizeUrlPreloadHtml);
                            }
                            $searchGlobal = $matches;
                            nlWallRecognizeUrl.get($searchGlobal, function($data){
                                $recognizeUrlTarget.html(nlWallHtml.recognize_url($data)).promise().done(function(){
                                    $recognizeUrlTarget.find(".cancel").unbind().click(function(){
                                        var $websiteLink = $(this).parents('.website-link:first');
                                        var $type = $websiteLink.data('type');
                                        var $url = $websiteLink.data('url');
                                        if($type == 'website-thumb'){
                                            $websiteLink.remove();
                                            if ($.inArray($url, $searchGlobal) >= 0) {
                                                $skipFromSearchGlobal.push($url);
                                            }
                                        }
                                    });
                                    libs.refreshTooltips();
                                });
                            });
                        }
                    }, 800);
                });
                $recognizeUrlTarget.find(".cancel").unbind().click(function(){
                    var $websiteLink = $(this).parents('.website-link:first');
                    var $type = $websiteLink.data('type');
                    var $url = $websiteLink.data('url');
                    if($type == 'website-thumb'){
                        $websiteLink.remove();
                        if ($.inArray($url, $searchGlobal) >= 0) {
                            $skipFromSearchGlobal.push($url);
                        }
                    }
                });
                if(cback != undefined){
                    cback();
                }
            },
            get:function($urls, cback){
                var $recognizeUrlUrl = $nlWallRecognizeUrlSettings.recognize_url_url;
                var $wallDebug = $nlWallSettings.wall_debug;
                var $withParams = $.extend({}, nlWallHelper.get_with_params(), {urls:$urls});
                $.ajax({
                    url:$recognizeUrlUrl,
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data:$withParams,
                    success: function ($data) {
                        libs.expire($data);
                        if($wallDebug){console.log($withParams);console.log($recognizeUrlUrl);console.log($data);}
                        if($data.status == 'success' && libs.memoryGet('prevent_load_post_binding')){
                            cback($data);
                        }
                    }
                });
            },
        };

        //nlWallUpdate
        var $nlWallUpdateDefaults = {
            wall_update_modal:function(){
                return $("#nurseslounge-home-activity-wall-update-modal");
            },
            wall_update_menu:"/myDashboard/activity/wallUpdateMenu/get",
            wall_update_analyze:"/myDashboard/activity/wallUpdateAnalyze/get",
            wall_update_save:"/myDashboard/activity/wallUpdateMenu/set",
        };
        if($nlWallUpdateOptions != undefined){
            $nlWallUpdateSettings = $.extend({}, $nlWallUpdateDefaults, $nlWallUpdateOptions);
        }else{
            $nlWallUpdateSettings = $.extend({}, $nlWallUpdateDefaults);
        }
        $nlWallUpdateOriginal = $nlWallUpdateDefaults;
        nlWallUpdate = {
            init:function($options, cback){
                $options = $options == undefined ? {} : $options;
                $options = $.extend({}, {
                    wall_update_button:function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.upload[data-id="0"]');
                    },
                    wall_update_preload_target: function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.preview[data-id="0"]');
                    },
                    wall_update_target: function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.preview[data-id="0"]');
                    },
                    wall_update_text_area:function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left").find('.post-text[data-id="0"]');
                    },
                    on_close_modal_callback:false,
                    on_end_callback:false,
                    get_data_callback:false,
                    wall_update_skip:[]
                }, $options);
                var $wallUpdateButton = $options.wall_update_button;
                var $modal = $nlWallUpdateSettings.wall_update_modal();
                var $modalContainer = $modal.find('.container:first');
                var $modalOptions = $modal.find('.options:first');
                var $onCloseModalCallback = $options.on_close_modal_callback;
                if($wallUpdateButton){
                    $wallUpdateButton().unbind().click(function(){
                        nlWallUpdate.container($options);
                    });
                }else{
                    nlWallUpdate.container($options);
                }
                $modal.unbind().on('hidden.bs.modal', function () {
                    Webcam.reset();
                    $modalContainer.html('');
                    $modalOptions.html('');
                    if($onCloseModalCallback){
                        $onCloseModalCallback();
                    }
                });
                if(cback != undefined){
                    cback();
                }
            },
            container:function($options){
                nlWallUpdate.popup($options, function($data){
                    nlWallUpdate.fill($data, $options);
                });
            },
            popup:function($options, cback){
                var $modal = $nlWallUpdateSettings.wall_update_modal();
                var $modalContainer = $modal.find('.container:first');
                var $modalOptions = $modal.find('.options:first');
                nlWallUpdate.menu($options, function($data){
                    var $optionsChtml = '';
                    $.each($data.data.options, function($i, $v){
                        $optionsChtml +='' +
                            '<li>' +
                            '    <a href="javascript:void(0)" class="action  d-flex align-items-center" data-action="'+$i+'">' +
                            '        <img src="/bimg/NursesLounge/'+$v.split(' ').join('_')+'.png" alt="'+$v+'" class="mr-2">' + $v +
                            '    </a>' +
                            '</li>';
                    });
                    $modalContainer.html('').promise().done(function(){
                        $modalOptions.html($optionsChtml).promise().done(function(){
                            $(this).find('.action').unbind().click(function(){
                                var $action = $(this).data('action');
                                if($action == 'album'){
                                    nlWallAlbum.open({
                                        on_close_modal:function(){
                                            var $albumModal =  $nlWallAlbumSettings.album_modal();
                                            $albumModal.modal('hide');
                                            var $updateModal = $nlWallUpdateSettings.wall_update_modal();
                                            $updateModal.modal('show');
                                        },
                                        on_end_callback:function(){
                                            var $albumModal =  $nlWallAlbumSettings.album_modal();
                                            $albumModal.unbind();
                                            $albumModal.modal('hide');
                                            $albumModal.css('display', 'none');
                                            $("body").removeClass('modal-open');
                                            $(".modal-backdrop").remove();
                                        },
                                        on_start_callback:function(){
                                            var $albumModal =  $nlWallAlbumSettings.album_modal();
                                            $albumModal.modal('show');
                                            var $updateModal = $nlWallUpdateSettings.wall_update_modal();
                                            $updateModal.unbind();
                                            $updateModal.modal('hide');
                                        },
                                        album_allow_tabs : {
                                            'profile_webcam_image':true,
                                            'profile_image':true,
                                            'profile_document':true,
                                            'profile_video':true,
                                            'profile_article':true
                                        },
                                        album_step:11,
                                        album_allow_add:true,
                                        album_allow_select:true
                                    }, function($document){
                                        nlWallUpdate.fill($document, $options);
                                    });
                                }else{
                                    nlWallUpdate.preview($action, $options, function($data){
                                        cback($data);
                                    });
                                }
                            });
                            libs.checkImageLoad($($optionsChtml).find('img'), function(){
                                $modal.modal('show');
                            });
                        });
                    });
                });
            },
            menu:function($options, cback){
                var $wallUpdateMenu = $nlWallUpdateSettings.wall_update_menu;
                var $wallDebug = $nlWallSettings.wall_debug;
                var $wallUpdateSkip = $options.wall_update_skip;
                var $withParams = $.extend({}, nlWallHelper.get_with_params(), {skip:$wallUpdateSkip});
                $.ajax({
                    url: $wallUpdateMenu,
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data:$withParams,
                    success: function ($data) {
                        libs.expire($data);
                        if($wallDebug){console.log($withParams);console.log($wallUpdateMenu);console.log($data);}
                        if($data.status == 'success'){
                            cback($data);
                        }
                    }
                });
            },
            preview:function($action, $options, cback){
                var $modal = $nlWallUpdateSettings.wall_update_modal();
                var $modalContainer = $modal.find('.container:first');
                var $modalOptions = $modal.find('.options:first');
                var $chtml = nlWallHtml.update_container($action);
                $modalContainer.html($chtml).promise().done(function(){
                    var $target = $(this);
                    var $imageContainer = $target.find('.image-container:first');
                    var $takePicture = $target.find(".take-camera-picture:first");
                    var $savePicture = $target.find(".save-camera-picture:first");
                    var $back = $target.find(".back:first");
                    if($action == 'webcam_image'){
                        $modalOptions.html('').promise().done(function(){
                            Webcam.reset();
                            Webcam.attach($imageContainer[0]);
                            $takePicture.unbind().click(function(){
                                Webcam.snap( function($imageBase64) {
                                    $imageContainer.html('').html('<img class="img-fluid" src="'+$imageBase64+'">').promise().done(function(){
                                        $takePicture.html('Reset').unbind().click(function(){
                                            nlWallUpdate.preview('webcam_image', $options,function(){
                                                cback();
                                            });
                                        });
                                        $savePicture.unbind().click(function(){
                                            $target.find('.camera-buttons').hide();
                                            nlWallUpdate.update($action, $imageBase64, $options, function($data){
                                                cback($data);
                                            });
                                        }).addClass('active');
                                    });
                                });
                            });
                        });
                        $back.unbind().click(function(){
                            nlWallUpdate.popup($options, cback);
                        });
                    }else{
                        $(this).find('input[type="file"]').unbind().change(function(){
                            var $fileInput = $(this);
                            nlWallUpdate.update($action, $fileInput, $options, cback);
                        }).click();
                    }
                });
            },
            update:function($action, $fileInput, $options, cback){
                var $withParams = nlWallHelper.get_with_params();
                var $wallUpdatePreloadHtml = nlWallHtml.update_preload();
                var $modal = $nlWallUpdateSettings.wall_update_modal();
                var $modalContainer = $modal.find('.container:first');
                var $modalOptions = $modal.find('.options:first');
                var $chtml = $modalContainer.html();
                $modalOptions.html('');
                $modalContainer.html($wallUpdatePreloadHtml).promise().done(function(){
                    var $formData = new FormData();
                    $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
                    if($action == 'webcam_image'){
                        Webcam.reset();
                        $formData.append('file', libs.b64toBlob($fileInput));
                    }else{
                        $formData.append('file', $fileInput[0].files[0]);
                    }
                    $formData.append('file_type', $action);
                    $formData.append('user_id', $withParams.user_id);
                    $formData.append('key', $withParams.key);
                    nlWallUpdate.analyze($formData, function($data){
                        if($data.status == 'error'){
                            cback($data);
                            return false;
                        }
                        $formData.append('thumb_file', libs.b64toBlob($data.data.features.thumb));
                        $formData.append('original_name', $data.data.features.original_name);
                        $modalContainer.html($chtml).promise().done(function(){
                            var $target = $(this);
                            var $imageContainer = $target.find('.image-container');
                            $imageContainer.width($target.width());
                            $imageContainer.height(300);
                            if(
                                $action == 'image' && $data.data.features.mime_type == 'image/png' ||
                                $action == 'image' && $data.data.features.mime_type == 'image/jpg' ||
                                $action == 'image' && $data.data.features.mime_type == 'image/jpeg' ||
                                $action == 'image' && $data.data.features.mime_type == 'image/gif'
                            ) {
                                $imageContainer.html('<img class="img-fluid" src="'+$data.data.features.preview+'">');
                            }
                            if(
                                $action == 'document' && $data.data.features.mime_type == 'application/pdf' ||
                                $action == 'document' && $data.data.features.mime_type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                                $action == 'document' && $data.data.features.mime_type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                                $action == 'document' && $data.data.features.mime_type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
                                $action == 'document' && $data.data.features.mime_type == 'application/CDFV2' ||
                                $action == 'document' && $data.data.features.mime_type == 'text/csv' ||
                                $action == 'document' && $data.data.features.mime_type == 'application/vnd.ms-excel' ||
                                $action == 'document' && $data.data.features.mime_type == 'application/msword' ||
                                $action == 'document' && $data.data.features.mime_type == 'text/plain'
                            ) {
                                if(PDFObject.supportsPDFs){
                                    PDFObject.embed($data.data.features.preview, $imageContainer, {
                                        height: "400px",
                                        pdfOpenParams: {
                                            view:'FitV',
                                            scrollbars: '0',
                                            toolbar: '0',
                                            statusbar: '0',
                                            navpanes: '0',
                                            page:'1'
                                        }
                                    });
                                } else {
                                    $imageContainer.html('<iframe id="pdfviewer" src="http://docs.google.com/gview?embedded=true&url='+$data.data.features.preview+'" frameborder="0" width="100%" height="100%"></iframe>');
                                }
                            }
                            if(
                                $action == 'video' && $data.data.features.mime_type == 'video/mp4' ||
                                $action == 'video' && $data.data.features.mime_type == 'video/x-msvideo' ||
                                $action == 'video' && $data.data.features.mime_type == 'video/mpeg' ||
                                $action == 'video' && $data.data.features.mime_type == 'video/quicktime' ||
                                $action == 'video' && $data.data.features.mime_type == 'video/x-flv' ||
                                $action == 'video' && $data.data.features.mime_type == 'video/x-matroska' ||
                                $action == 'video' && $data.data.features.mime_type == 'video/x-ms-asf'
                            ) {
                                var $player = new Artplayer({
                                    destroy:true,
                                    container: $imageContainer[0],
                                    title:  $data.data.features.original_name,
                                    url:    $data.data.features.preview  + '?temporal=true',
                                    poster: $data.data.features.thumb,
                                    autoplay: true,
                                    type: 'mp4',
                                    mutex: true,
                                    muted: false,
                                    play: true,
                                    pause: false,
                                    toggle: false,
                                    miniProgressBar: true,
                                    loop: true,
                                    fullscreen: false,
                                    fullscreenToggle: false,
                                    fullscreenWeb: false,
                                    fullscreenWebToggle: false,
                                    fullscreenRotate: false,
                                    fullscreenRotateToggle: false,
                                    moreVideoAttr: {
                                        crossOrigin: 'anonymous',
                                        playsInline: true,
                                        'webkit-playsinline': true,
                                        'x5-video-player-type': 'h5',
                                        'x5-video-player-fullscreen': false,
                                        'x5-video-orientation': 'portraint',
                                    },
                                    whitelist:['*']
                                }).on('ready', function () {
                                    $player.player.pause = true;
                                    $player.player.play = true;
                                });
                                $player.mask.show = false;
                            }
                            $modalOptions.html('').html(nlWallHtml.update_options()).promise().done(function(){
                                var $fileType = $action;
                                $modalOptions.find('.action').unbind().click(function(){
                                    var $action = $(this).data('action');
                                    if($player != undefined){
                                        $player.player.pause = true;
                                        $player.destroy();
                                    }
                                    $modalOptions.html('');
                                    $modalContainer.html($wallUpdatePreloadHtml).promise().done(function(){
                                        switch($action){
                                            case 'save':
                                                if($fileInput != ''){
                                                    if($fileType == 'image' || $fileType == 'webcam_image' || $fileType == 'document'){
                                                        $formData.append('preview_file', libs.b64toBlob($data.data.features.preview));
                                                    }
                                                    if($fileType == 'video'){
                                                        $formData.append('preview_file', $data.data.features.preview);
                                                        $formData.append('preview_root', $data.data.features.preview_root);
                                                    }
                                                    $formData.append('action', $action);
                                                    $formData.append('file_type', $fileType);
                                                    var $wallUpdatePreloadTarget = $nlWallUpdateSettings.wall_update_preload_target;
                                                    if($wallUpdatePreloadTarget){
                                                        $wallUpdatePreloadTarget().html(nlWallHtml.update_preload()).promise().done(function(){
                                                            nlWallUpdate.save($formData, function($data){
                                                                $data = $.extend($data, {action:$fileType});
                                                                cback($data);
                                                            });
                                                        });
                                                    }else{
                                                        nlWallUpdate.save($formData, function($data){
                                                            $data = $.extend($data, {action:$fileType});
                                                            cback($data);
                                                        });
                                                    }
                                                }
                                                break;
                                            case 'back':
                                                $modalContainer.html('').promise().done(function(){
                                                    nlWallUpdate.popup($options, cback);
                                                });
                                                break;
                                        }
                                    });
                                });
                            });
                        });
                    });
                });
            },
            analyze:function($formData, cback){
                var $wallUpdateAnalyze = $nlWallUpdateSettings.wall_update_analyze;
                var $wallDebug = $nlWallSettings.wall_debug;
                $.ajax({
                    type: 'POST',
                    url: $wallUpdateAnalyze,
                    data: $formData,
                    cache: false,
                    contentType: false,
                    processData: false,
                    success: function ($data) {
                        libs.expire($data);
                        if($wallDebug){console.log($formData);console.log($wallUpdateAnalyze);console.log($data);}
                        cback($data);
                    }
                });
            },
            save:function($formData, cback){
                var $wallUpdateSave = $nlWallUpdateSettings.wall_update_save;
                var $wallDebug = $nlWallSettings.wall_debug;
                $.ajax({
                    type: 'POST',
                    url: $wallUpdateSave,
                    data: $formData,
                    cache: false,
                    contentType: false,
                    processData: false,
                    success: function ($data) {
                        libs.expire($data);
                        if($wallDebug){console.log($formData);console.log($wallUpdateSave);console.log($data);}
                        if ($data.status == 'success') {
                            cback($data);
                        }
                    }
                });
            },
            fill:function($data, $options){
                var $modal = $nlWallUpdateSettings.wall_update_modal();
                var $wallUpdateTextArea = $options.wall_update_text_area;
                var $onEndCallback = $options.on_end_callback;
                var $getDataCallback = $options.get_data_callback;
                var $wallUpdateTarget = $options.wall_update_target;
                var $albumModal =  $nlWallAlbumSettings.album_modal();
                var $albumModalTab = $albumModal.find('.nav-pills .nav-link[data-target="#profile_'+$data.action+'"]');
                if($data.status == 'error'){
                    $modal.modal('hide');
                }else
                if($wallUpdateTextArea && false){
                    var $txt = $wallUpdateTextArea().val();
                    $wallUpdateTextArea().val($txt + '\n' + $data.data.updated_file.name).keypress();
                }
                if($getDataCallback){
                    $getDataCallback($data);
                    if(!$albumModalTab.hasClass('disabled')){
                        $albumModalTab.click();
                    }
                    if($onEndCallback){
                        $onEndCallback();
                    }else{
                        $modal.modal('hide');
                    }
                }else
                if(
                    $data.action == 'image' ||
                    $data.action == 'document' ||
                    $data.action == 'video' ||
                    $data.action == 'webcam_image' ||
                    $data.action == 'article'
                ){
                    var $chtml = nlWallHtml.update_wall($data.data.updated_file);
                    libs.checkImageLoad($($chtml).find('img'), function(){
                        $wallUpdateTarget().html($chtml).promise().done(function(){
                            $wallUpdateTarget().find(".cancel").unbind().click(function(){
                                var $websiteAttach = $(this).parents('.website-attach:first');
                                var $type = $websiteAttach.data('type');
                                if($type == 'website-document'){
                                    $websiteAttach.remove();
                                }
                            });
                            libs.refreshTooltips();
                            if(!$albumModalTab.hasClass('disabled')){
                                $albumModalTab.click();
                            }
                            if($onEndCallback){
                                $onEndCallback();
                            }else{
                                $modal.modal('hide');
                            }
                        });
                    });
                }
            },
        };

        //nlWallAlbum
        var $nlWallAlbumDefaults = {
            album_modal:function(){
                return $("#nurseslounge-home-activity-wall-album-modal");
            },
            album_view:"/myDashboard/activity/wallAlbumView/get",
            album_delete:"/myDashboard/activity/wallAlbumView/delete",
        };
        if($nlWallAlbumOptions != undefined){
            $nlWallAlbumSettings = $.extend({}, $nlWallAlbumDefaults, $nlWallAlbumOptions);
        }else{
            $nlWallAlbumSettings = $.extend({}, $nlWallAlbumDefaults);
        }
        $nlWallAlbumOriginal = $nlWallAlbumDefaults;
        nlWallAlbum = {
            open:function($options, selectedDocument){
                $options = $options == undefined ? {} : $options;
                $options = $.extend({}, {
                    on_close_modal:false,
                    on_end_callback:false,
                    on_start_callback:false,
                    album_allow_tabs : {
                        'profile_webcam_image':true,
                        'profile_image':true,
                        'profile_document':true,
                        'profile_video':true,
                        'profile_article':false
                    },
                    album_step:11,
                    album_allow_add:true,
                    album_allow_select:true
                }, $options);

                var $modal = $nlWallAlbumSettings.album_modal();
                var $onCloseModal = $options.on_close_modal;
                var $albumAllowTabs = $options.album_allow_tabs;
                var $allowTabsFiltered = $albumAllowTabs;
                $albumAllowTabs = {};
                $.each($allowTabsFiltered, function($k, $v) {var $newObj = {};$newObj[$k]=$v;if($v){$.extend($albumAllowTabs, $newObj);}});
                if(!$modal.is(':visible') && $onCloseModal){
                    $modal.unbind().on('hidden.bs.modal', function () {
                        $onCloseModal();
                    });
                }
                $modal.find('.nav-pills .nav-link').addClass('disabled').removeClass('active');
                $modal.find('.album-modal-container .tab-pane .container').html('');
                //Events
                $modal.find('.nav-pills a[data-toggle="tab"]').unbind().on('shown.bs.tab', function ($e) {
                    var $selectedTab = $e.currentTarget.dataset.target.replace('#','');
                    if($.inArray($selectedTab, Object.keys($albumAllowTabs)) > -1){
                        nlWallAlbum.tab($selectedTab, $options, function($document){
                            selectedDocument($document);
                        });
                    }
                });
                //Enable selected
                $.each($albumAllowTabs, function ($i, $v) {
                    $modal.find('.nav-pills .nav-link[data-target="#'+$i+'"]').removeClass('disabled');
                });
                $.each($albumAllowTabs, function($i, $v) {
                    if($v){
                        $modal.find('.nav-pills .nav-link[data-target="#'+$i+'"]').click();
                        return false;
                    }
                });
            },
            tab:function($selectedTab, $options, selectedDocument){
                var $modal = $nlWallAlbumSettings.album_modal();
                var $onEndCallback = $options.on_end_callback;
                var $onStartCallback = $options.on_start_callback;
                var $albumStep = $options.album_step;
                var $modalContainer = $modal.find('.album-modal-container:first');
                var $loadMoreAfterPercent = 90;
                var $scrollBinding;
                var $albumLength;
                var $updateModal = $nlWallUpdateSettings.wall_update_modal();
                var $container = $updateModal.find('.container:first');
                var $optionsDiv = $updateModal.find('.options:first');
                $optionsDiv.hide();
                $container.html(nlWallHtml.update_preload()).promise().done(function() {
                    nlWallAlbum.view($selectedTab, 'view', $options, function ($chtml) {
                        $modal.find('#' + $selectedTab).html($chtml).promise().done(function () {
                            var $modalWrapper = $modalContainer.find('#' + $selectedTab);
                            var $preload = $modalWrapper.find('.preload');
                            $modalWrapper.unbind().scroll(function () {
                                var $maxScrollTop = $modalWrapper[0].scrollHeight - $modalWrapper.height();
                                var $actualScroll = $modalWrapper.scrollTop();
                                var $triggerPercent = ($actualScroll * 100) / $maxScrollTop > $loadMoreAfterPercent;
                                if ($triggerPercent) {
                                    try {
                                        clearTimeout($scrollBinding);
                                    } catch (e) {
                                    }
                                    $scrollBinding = setTimeout(function () {
                                        $albumLength = $modalWrapper.find('div:first .item').length;
                                        libs.memorySave('album-offset' + $selectedTab, $albumLength);
                                        libs.memorySave('album-limit' + $selectedTab, $albumStep);
                                        nlWallAlbum.view($selectedTab, 'json', $options, function ($data) {
                                            var $chtml = nlWallHtml.album_view_html($data);
                                            libs.checkImageLoad($($chtml).find('img'), function () {
                                                $modalWrapper.find('div:first').append($chtml).ready(function () {
                                                    $albumLength = $modalWrapper.find('div:first .item').length;
                                                    if ($albumLength >= $data.data.documents_count) {
                                                        $preload.hide();
                                                    } else {
                                                        $preload.show();
                                                    }
                                                    nlWallAlbum.events($options, function () {
                                                    }, function ($document) {
                                                        if ($onEndCallback) {
                                                            $onEndCallback();
                                                        } else {
                                                            $modal.modal('hide');
                                                        }
                                                        selectedDocument($document);
                                                    });
                                                });
                                            });
                                        });
                                    }, 1000);
                                }
                            });
                            nlWallAlbum.events($options, function () {
                                libs.checkImageLoad($($chtml).find('img'), function () {
                                    if ($onStartCallback) {
                                        $onStartCallback();
                                    } else {
                                        $modal.modal('show');
                                    }
                                    $optionsDiv.show();
                                    $container.html('');
                                });
                            }, function ($document) {
                                if ($onEndCallback) {
                                    $onEndCallback();
                                } else {
                                    $modal.modal('hide');
                                }
                                selectedDocument($document);
                            });
                        });
                    });
                });
            },
            view:function($selectedTab, $only, $options, cback){
                var $albumStep = $options.album_step;
                var $albumAllowAdd = $options.album_allow_add;
                var $withParams = nlWallHelper.get_with_params();
                var $modal = $nlWallAlbumSettings.album_modal();
                var $modalContainer = $modal.find('.album-modal-container:first');
                var $modalWrapper = $modalContainer.find('#'+$selectedTab);
                var $albumLength;
                if($only == 'view'){
                    libs.memorySave('album-offset'+$selectedTab, 0);
                    if(!libs.memoryGet('album-limit'+$selectedTab)){
                        libs.memorySave('album-limit'+$selectedTab, $albumStep);
                    }
                }else{
                    $albumLength = $modalWrapper.find('div:first .item').length;
                    libs.memorySave('album-limit'+$selectedTab, $albumLength);
                }
                var $offset = libs.memoryGet('album-offset'+$selectedTab);
                var $limit = libs.memoryGet('album-limit'+$selectedTab);
                var $albumView = $nlWallAlbumSettings.album_view;
                var $wallDebug = $nlWallSettings.wall_debug;
                $withParams = $.extend({}, $withParams, {type:$selectedTab, allow_add:$albumAllowAdd, only:$only, offset:$offset, limit:$limit});
                $.ajax({
                    url:$albumView,
                    method: "POST",
                    cache:false,
                    dataType: $only == 'view' ? 'html' : 'json',
                    data:$withParams,
                    success: function ($data) {
                        libs.expire($data);
                        if($wallDebug){console.log($withParams);console.log($albumView);console.log($data);}
                        cback($data);
                    }
                });
            },
            events:function($options, cback, selectedDocument){
                var $modal = $nlWallAlbumSettings.album_modal();
                var $image = $modal.find('.img-contain img');
                var $addDocument = $modal.find('.btn-add-document');
                var $deleteDocument = $modal.find('.btn-delete');
                var $albumAllowSelect = $options.album_allow_select;
                var $holdTime;
                $image.unbind();
                if($albumAllowSelect) {
                    $image.click(function () {
                        var $that = $(this);
                        var $modal = $nlWallAlbumSettings.album_modal();
                        $modal.unbind();
                        selectedDocument(
                            {
                                action: $that.data('filetype'),
                                data: {
                                    updated_file: {
                                        id: $that.data('id'),
                                        name: $that.data('name'),
                                        document_root: $that.data('documentroot'),
                                        type: $that.data('type'),
                                        size: $that.data('size'),
                                        file_type: $that.data('filetype'),
                                        thumb_name: $that.data('thumbname'),
                                        document_thumb_root: $that.data('documentthumbroot'),
                                        thumb_type: $that.data('thumbtype'),
                                        thumb_size: $that.data('thumbsize'),
                                        preview_name: $that.data('previewname'),
                                        document_preview_root: $that.data('documentpreviewroot'),
                                        preview_type: $that.data('previewtype'),
                                        preview_size: $that.data('previewsize'),
                                        date: $that.data('date')
                                    }
                                }
                            }
                        );
                    }).on('mousedown', function() {
                        var $that = $(this);
                        var $id = $that.data('id');
                        $holdTime = setTimeout(function(){
                            nlWallDocumentPreview.init($id);
                        }, 1000);
                    }).on('mouseup mouseleave', function() {
                        clearTimeout($holdTime);
                    });
                }else{
                    $image.click(function () {
                        var $that = $(this);
                        var $id = $that.data('id');
                        nlWallDocumentPreview.init($id);
                    });
                }
                $addDocument.unbind().click(function(){
                    $modal.unbind();
                    nlWallUpdate.init({
                        wall_update_button:false,
                        wall_update_preload_target:false,
                        wall_update_target:false,
                        wall_update_text_area:false,
                        wall_update_skip:['album'],
                        on_close_modal_callback:function(){
                            var $albumModal =  $nlWallAlbumSettings.album_modal();
                            $albumModal.modal('show');
                        },
                        on_end_callback:false,
                        get_data_callback:function($updatedDocument){
                            var $tab = $updatedDocument.data.updated_file.file_type;
                            var $modal = $nlWallAlbumSettings.album_modal();
                            nlWallAlbum.tab('profile_'+$tab, {
                                on_close_modal:false,
                                on_end_callback:false,
                                on_start_callback:function(){
                                    $modal.find('.nav-pills .nav-link[data-target="#'+$tab+'"]').click();
                                },
                                album_allow_tabs : {
                                    'profile_webcam_image':true,
                                    'profile_image':true,
                                    'profile_document':true,
                                    'profile_video':true,
                                    'profile_article':false
                                },
                                album_step:11,
                                album_allow_add:true,
                                album_allow_select:true
                            }, function($document){
                                selectedDocument($document);
                            });
                        }
                    },function(){
                        $modal.modal('hide');
                    });
                });
                $deleteDocument.unbind().click(function($e){
                    $e.stopPropagation();
                    var $that = $(this);
                    var $item = $that.parents('.item:first');
                    var $id = $item.find('img:first').data('id');
                    if(confirm('Delete this document!\nThis will permanently delete the document from all the Post and Articles where it is used')){
                        nlWallAlbum.delete($id, function(){
                            $item.remove();
                        });
                    }
                });
                cback();
            },
            delete:function($id, cback){
                var $albumDelete = $nlWallAlbumSettings.album_delete;
                var $wallDebug = $nlWallSettings.wall_debug;
                var $withParams = $.extend({}, nlWallHelper.get_with_params(), {id:$id});
                $.ajax({
                    url:$albumDelete,
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data:$withParams,
                    success: function ($data) {
                        libs.expire($data);
                        if($wallDebug){console.log($withParams);console.log($albumDelete);console.log($data);}
                        if($data.status == 'success'){
                            cback($data);
                        }
                    }
                });
            },
        };

        //nlWallDocumentPreview
        var $nlWallDocumentPreviewDefaults = {
            wall_document_preview_get:"/myDashboard/activity/wallDocument/get",
            wall_document_social_share:"/myDashboard/activity/wallDocument/socialShare",
            photo_swipe_image_target:function(){
                return $('#nurseslounge-home-activity-wall-photoswipe-image');
            },
            photo_swipe_document_target:function(){
                return $('#nurseslounge-home-activity-wall-photoswipe-document');
            },
            photo_swipe_video_target:function(){
                return $('#nurseslounge-home-activity-wall-photoswipe-video');
            },
            photo_swipe_article_target:function(){
                return $('#nurseslounge-home-activity-wall-photoswipe-article');
            }
        };
        if($nlWallDocumentPreviewOptions != undefined){
            $nlWallDocumentPreviewSettings = $.extend({}, $nlWallDocumentPreviewDefaults, $nlWallDocumentPreviewOptions);
        }else{
            $nlWallDocumentPreviewSettings = $.extend({}, $nlWallDocumentPreviewDefaults);
        }
        $nlWallDocumentPreviewOriginal = $nlWallDocumentPreviewDefaults;

        nlWallDocumentPreview =  {
            init:function($documentId){
                nlWallDocumentPreview.get($documentId, function($data){
                    var $id = $data.data.document.id;
                    var $type = $data.data.document.file_type;
                    var $document = $data.data.document;
                    libs.memorySave($type+$id, $document);
                    nlWallDocumentPreview.popup($type, $id);
                });
            },
            get:function($id, cback){
                var $wallDocumentPreviewGet = $nlWallDocumentPreviewSettings.wall_document_preview_get;
                var $wallDebug = $nlWallSettings.wall_debug;
                var $withParams = $.extend({}, nlWallHelper.get_with_params(), {id:$id});
                $.ajax({
                    url:$wallDocumentPreviewGet,
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data:$withParams,
                    success: function ($data) {
                        libs.expire($data);
                        if($wallDebug){console.log($withParams);console.log($wallDocumentPreviewGet);console.log($data);}
                        cback($data);
                    }
                });
            },
            social_share:function($photoSwipe, $name, $id){
                var $chtml = '' +
                    '<div class="pswp__share-modal pswp__single-tap social-share">' +
                    '   <div class="pswp__share-tooltip">' +
                    '       <a class="col-1 share-with" href="javascript:void(0)" data-action="linkedin">' +
                    '           <i class="fa fa-linkedin social-icons linkedin-color my-1"></i>' +
                    '       </a>' +
                    '       <a class="col-1 share-with" href="javascript:void(0)" data-action="pinterest">' +
                    '           <i class="fa fa-pinterest-p social-icons pint-color my-1"></i>' +
                    '       </a>' +
                    '       <a class="col-1 share-with" href="javascript:void(0)" data-action="twitter">' +
                    '           <i class="fa fa-twitter social-icons twitter-color my-1"></i>' +
                    '       </a>' +
                    '       <a class="col-1 share-with" href="javascript:void(0)" data-action="facebook">' +
                    '           <i class="fa fa-facebook social-icons facebook-color my-1"></i>' +
                    '       </a>' +
                    '   </div>'+
                    '</div>';
                var $button = $photoSwipe.find('.pswp__' + $name + ':first');
                if($button.find('.pswp__single-tap:first').length == 0){
                    $button.append($chtml).ready(function(){
                        $photoSwipe.unbind('click').click(function(){
                            $button.find('.pswp__share-modal:first').removeClass('pswp__share-modal--fade-in');
                            $button.find('.pswp__share-modal:first').addClass('pswp__share-modal--hidden');
                        });
                        $button.find('.share-with').unbind().click(function(){
                            var $action = $(this).data('action');
                            nlWallDocumentPreview.social_share_request($id, function($data){
                                var $document = $data.data.document;
                                var $name = $document.name;
                                var $thumb = $document.document_thumb_root;
                                $thumb = encodeURIComponent($thumb);
                                var $shareLink = $document.share_link;
                                $shareLink = encodeURIComponent($shareLink);
                                var $url = encodeURIComponent(window.location.href);
                                var $features = '';
                                switch ($action) {
                                    case 'facebook':
                                        window.open('https://www.facebook.com/sharer/sharer.php?u=' + $shareLink, '_blank', $features);
                                    break;
                                    case 'twitter':
                                        window.open('https://twitter.com/intent/tweet?url=' + $shareLink + '&text=' + $name, '_blank', $features);
                                    break;
                                    case 'pinterest':
                                        window.open('http://www.pinterest.com/pin/create/button?url=' + $url + '&media=' + $thumb + '&description=' + $name, '_blank', $features);
                                    break;
                                    case 'linkedin':
                                        window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + $shareLink, '_blank', $features);
                                    break;
                                }
                            });
                        });
                    });
                }
                $button.find('.pswp__share-modal:first').removeClass('pswp__share-modal--hidden');
                $button.find('.pswp__share-modal:first').addClass('pswp__share-modal--fade-in');
                $button.unbind('click').click(function($e){
                    $e.stopPropagation();
                });
            },
            social_share_request:function($id, cback){
                var $wallDocumentSocialShare = $nlWallDocumentPreviewSettings.wall_document_social_share;
                var $wallDebug = $nlWallSettings.wall_debug;
                var $withParams = $.extend({}, nlWallHelper.get_with_params(), {id:$id});
                $.ajax({
                    url:$wallDocumentSocialShare,
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data:$withParams,
                    success: function ($data) {
                        libs.expire($data);
                        if($wallDebug){console.log($withParams);console.log($wallDocumentSocialShare);console.log($data);}
                        cback($data);
                    }
                });
            },
            popup:function($type, $id, $function, cback){
                var $photoSwipeImage = $nlWallDocumentPreviewSettings.photo_swipe_image_target();
                var $photoSwipeDocument = $nlWallDocumentPreviewSettings.photo_swipe_document_target();
                var $photoSwipeVideo = $nlWallDocumentPreviewSettings.photo_swipe_video_target();
                var $photoSwipeArticle = $nlWallDocumentPreviewSettings.photo_swipe_article_target();
                var $data = libs.memoryGet($type+$id);
                var $original;
                var $preview;
                var $thumb;
                var $mimeType;
                var $name;
                var $documentKey;
                var $documentDate;
                var $userLongName;
                var $userImage;
                var $articleHtml;
                var $articleHeadline;
                var $articleSingleImage;
                var $specialty;
                var $degree;
                var $articleTags = [];
                var $link;
                var $gallery;
                var $expirationDate;
                var $categories;
                var $categoriesTxt = [];

                if(
                    $type == 'image' ||
                    $type == 'webcam_image' ||
                    $type == 'document' ||
                    $type == 'video' ||
                    $type == 'article'
                ){
                    $original = $data.document_root ? $data.document_root : null;
                    $preview = $data.document_preview_root ? $data.document_preview_root : null;
                    $thumb = $data.document_thumb_root ? $data.document_thumb_root : null;
                    $mimeType = $data.type ? $data.type : null;
                    $name = $data.name ? $data.name : null;
                    $documentKey = $data.key ? $data.key : null;
                    $documentDate = $data.date ?  moment.utc($data.date, 'YYYY-MM-DD HH:mm:ss').local().format('MMMM, DD YYYY hh:mm A') : null;
                    $userLongName = $data.user && $data.user.long_name ? $data.user.long_name : null;
                    $userImage = $data.user &&  $data.user.profile_image_root_wall ? $data.user.profile_image_root_wall : null;
                    $articleHtml = $data.article_features &&  $data.article_features.html ? $data.article_features.html : null;
                    $articleHeadline = $data.article_features &&  $data.article_features.headline ? $data.article_features.headline : null;
                    $articleSingleImage = $data.article_features && $data.article_features.image && $data.article_features.image.document_root ? $data.article_features.image.document_root : null;
                    $degree = $data.article_features && $data.article_features.degree && $data.article_features.degree.subcategory ? $data.article_features.degree.subcategory : null;
                    $specialty = $data.article_features && $data.article_features.specialty && $data.article_features.specialty.type ? $data.article_features.specialty.type : null;
                    $expirationDate = $data.article_features && $data.article_features.expiration_date ? moment.utc($data.article_features.expiration_date, 'YYYY/MM/DD').format('MMMM, DD YYYY') : null;
                    $categories = $data.article_categories ? $data.article_categories : null;

                    if($specialty){
                        $articleTags.push({tag:$specialty});
                    }
                    if($degree) {
                        $articleTags.push({tag:$degree});
                    }
                    if($data.article_tags){
                        $articleTags = $.merge($articleTags, $data.article_tags);
                    }
                    if($categories){
                        for(var $i in $categories){
                            $categoriesTxt.push($categories[$i].category.category);
                        }
                    }
                }else{
                    $link = $data.patternUrl;
                }
                if(
                    $type == 'image' ||
                    $type == 'webcam_image'
                ){
                    libs.getImageWH($original, function($w, $h){
                        $gallery = new PhotoSwipe($photoSwipeImage[0], PhotoSwipeUI_Default,
                            [
                                {
                                    src: $original,
                                    w: $w,
                                    h: $h
                                },
                            ],
                            {
                                index: 0,
                                clickToCloseNonZoomable: false,
                                closeOnScroll: false,
                                closeOnVerticalDrag:false,
                                closeElClasses: [],
                                history:false,
                                shareButtons: [
                                    {
                                        id:'downloadOriginal',
                                        label:'Download Original',
                                        url:$original+'?name='+$name+'&download=true',
                                        download:true
                                    }
                                ],
                                socialShareEvent:function($this){
                                    nlWallDocumentPreview.social_share($photoSwipeImage, $this.name, $id);
                                }
                            }
                    );
                        $gallery.init();
                        //var $api = $gallery.ui.getFullscreenAPI();
                        //$api.enter();
                        $("body").css('overflowY', 'hidden');
                        $gallery.listen('close', function() {
                            $photoSwipeImage.find(".pswp__zoom-wrap").html('');
                            $("body").css('overflowY', 'scroll');
                            if(cback != undefined){
                                cback();
                            }
                        });
                    });
                }
                if($type == 'document'){
                    var $chtml = '' +
                        '<div class="preview-image-container">' +
                        '   <div class="image">' +
                        '   </div>' +
                        '</div>';
                    var $shareButtons;
                    if($mimeType == 'application/pdf'){
                        $shareButtons = [
                            {
                                id:'downloadOriginal',
                                label:'Download Original',
                                url:$original+'?name='+$name+'&download=true',
                                download:true
                            }
                        ];
                    }else{
                        $shareButtons = [
                            {
                                id:'downloadPdf',
                                label:'Download PDF',
                                url:$preview+'?name='+$name+'&download=true',
                                download:true
                            },
                            {
                                id:'downloadOriginal',
                                label:'Download Original',
                                url:$original+'?name='+$name+'&download=true',
                                download:true
                            }
                        ];
                    }
                    $gallery = new PhotoSwipe($photoSwipeDocument[0], PhotoSwipeUI_Default,
                        [
                            {
                                html: $chtml
                            }
                        ],
                        {
                            index: 0,
                            clickToCloseNonZoomable: false,
                            closeOnScroll: false,
                            closeOnVerticalDrag:false,
                            closeElClasses: [],
                            history:false,
                            shareButtons: $shareButtons,
                            socialShareEvent:function($this){
                                nlWallDocumentPreview.social_share($photoSwipeDocument, $this.name, $id);
                            }
                        }
                    );
                    $gallery.init();
                    var $container = $photoSwipeDocument.find('.preview-image-container');
                    var $target = $container.find('.image:first');
                    $target.width($(window).width());
                    $target.height($(window).height());
                    if(PDFObject.supportsPDFs){
                        PDFObject.embed($preview, $target, {
                            height: "400px",
                            pdfOpenParams: {
                                view:'FitV',
                                scrollbars: '0',
                                toolbar: '0',
                                statusbar: '0',
                                navpanes: '0',
                                page:'1'
                            }
                        });
                    } else {
                        $target.html('<iframe id="pdfviewer" src="http://docs.google.com/gview?embedded=true&url='+$preview+'" frameborder="0" width="100%" height="100%"></iframe>');
                    }
                    var $fullscreen = false;
                    //var $api = $gallery.ui.getFullscreenAPI();
                    //$api.enter();
                    var $pdfobjectOriginalH = $(window).height();
                    var $pdfobjectFullH;
                    $("body").css('overflowY', 'hidden');
                    $target.find('.pdfobject').height($pdfobjectOriginalH);
                    $gallery.listen('close', function() {
                        $container.remove();
                        $("body").css('overflowY', 'scroll');
                        if(cback != undefined){
                            cback();
                        }
                    });
                    $gallery.listen('beforeResize', function() {
                        if(!$fullscreen){
                            $target.find('.pdfobject').height($(window).height());
                        }else{
                            $target.find('.pdfobject').height($pdfobjectOriginalH);
                        }
                        $fullscreen = !$fullscreen;
                    });
                }
                if($type == 'video'){
                    var $chtml = '' +
                        '<div class="preview-image-container">' +
                        '   <div class="image">' +
                        '   </div>' +
                        '</div>';
                    $gallery = new PhotoSwipe($photoSwipeVideo[0], PhotoSwipeUI_Default,
                        [
                            {
                                html: $chtml
                            }
                        ],
                        {
                            index: 0,
                            clickToCloseNonZoomable: false,
                            closeOnScroll: false,
                            closeOnVerticalDrag:false,
                            closeElClasses: [],
                            history:false,
                            shareButtons: [
                                {
                                    id:'downloadOriginal',
                                    label:'Download Original',
                                    url:$original+'?name='+$name+'&download=true',
                                    download:true
                                }
                            ],
                            socialShareEvent:function($this){
                                nlWallDocumentPreview.social_share($photoSwipeVideo, $this.name, $id);
                            }
                        }
                    );
                    $gallery.init();
                    var $smallPlayer = libs.memoryGet('player'+$id);
                    if($smallPlayer){
                        $smallPlayer.player.pause = true;
                    }
                    var $container = $photoSwipeVideo.find('.preview-image-container');
                    var $target = $container.find('.image:first');
                    $target.width($(window).width());
                    $target.height($(window).height());
                    var $previewPlayer = new Artplayer({
                        destroy:true,
                        container: $target[0],
                        title: $original,
                        url: $preview  + '?temporal=true',
                        poster: $thumb,
                        type: 'mp4',
                        mutex: true,
                        muted: false,
                        play: false,
                        pause: true,
                        autoplay: true,
                        toggle: false,
                        miniProgressBar: true,
                        loop: true,
                        fullscreen: false,
                        fullscreenToggle: false,
                        fullscreenWeb: false,
                        fullscreenWebToggle: false,
                        fullscreenRotate: false,
                        fullscreenRotateToggle: false,
                        moreVideoAttr: {
                            crossOrigin: 'anonymous',
                            playsInline: true,
                            'webkit-playsinline': true,
                            'x5-video-player-type': 'h5',
                            'x5-video-player-fullscreen': false,
                            'x5-video-orientation': 'portraint',
                        },
                        whitelist:['*']
                    }).on('ready', function () {
                        $previewPlayer.player.play = true;
                        libs.refreshTooltips();
                    });
                    $previewPlayer.mask.show = false;
                    var $fullscreen = false;
                    //var $api = $gallery.ui.getFullscreenAPI();
                    //$api.enter();
                    $("body").css('overflowY', 'hidden');
                    $gallery.listen('close', function() {
                        $("body").css('overflowY', 'scroll');
                        $container.remove();
                        $previewPlayer.player.pause = true;
                        $previewPlayer.destroy();
                        if($smallPlayer) {
                            $smallPlayer.player.play = true;
                        }
                        if(cback != undefined){
                            cback();
                        }
                    });
                    $gallery.listen('beforeResize', function() {
                        if($fullscreen){
                            $target.height($(window).height());
                        }else{
                            $target.height($(window).height());
                        }
                        $fullscreen = !$fullscreen;
                    });
                }
                if($type == 'article'){
                    if($documentKey != null){
                        var $winHandle = window.open(window.location.origin + '/article/' + $documentKey,'nurseslounge_myDashboard_wall_article_popup_'+$documentKey);
                        if ($winHandle != null){
                            return false;
                        }
                    }
                    var $articleDisabled = libs.isEmptyReturnNull($function) == null ? [] : $function.article.disabled;
                    var $shareEl = false;
                    var $shareButtons = [];
                    if($.inArray('download', $articleDisabled) == -1){
                        $shareEl = true;
                        $shareButtons.push({
                            id:'downloadOriginal',
                            label:'Download Original',
                            url:$preview+'?name='+$name+'&download=true',
                            download:true
                        });
                    }
                    var $chtml = '' +
                        '<div class="preview-image-container">' +
                        '   <div class="image">' +
                        '   </div>' +
                        '</div>';
                    $gallery = new PhotoSwipe($photoSwipeArticle[0], PhotoSwipeUI_Default,
                        [
                            {
                                html: $chtml
                            }
                        ],
                        {
                            index: 0,
                            clickToCloseNonZoomable: false,
                            closeOnScroll: false,
                            closeOnVerticalDrag:false,
                            closeElClasses: [],
                            history:false,
                            shareEl: $shareEl,
                            shareButtons: $shareButtons
                        }
                    );
                    $gallery.init();
                    var $container = $photoSwipeArticle.find('.preview-image-container');
                    var $target = $container.find('.image:first');
                    var $chtml = '';
                    $chtml += '' +
                        '<div class="col-12 mt-4">' +
                        ' <div class="card card-aboutbox card-box mb-4">' +
                        '     <div class="card-body p-0">' +
                        '         <div class="article-list-holder border-top pt-3 px-3">' +
                        '             <div class="article-list-container">' +
                        '                 <div class="row">' +
                        '                     <div class="col-md-12">' +
                        '                         <div class="card article-card shadow-none">' +
                        '                             <div class="d-flex p-3 row">' +
                        '                                 <div class="list-info align-self-center text-nowrap w-100">' +
                        '                                     <p class="float-right">'+$documentDate+'</p>' +
                        '                                 </div>';
                    if($expirationDate){
                        $chtml += '' +
                            '                                 <div class="list-info align-self-center text-nowrap w-100">' +
                            '                                     <p class="float-right">Expire: '+$expirationDate+'</p>' +
                            '                                 </div>';
                    }
                    $chtml += '' +
                        '                                 <div class="profile-img mr-3 col-12 m-0 p-0 col-lg-auto">' +
                        '                                     <img src="'+$userImage+'" alt="profile">' +
                        '                                 </div>' +
                        '                                 <div class="list-info align-self-center w-100 col-12 my-1 p-0 col-lg-8">' +
                        '                                     <h4>'+$userLongName+'</h4>' +
                        '                                 </div>' +
                        '                             </div>';
                    if($articleSingleImage) {
                        $chtml += '' +
                            '                             <div class="article-single-image mx-0 px-0">' +
                            '                                 <img src="'+$articleSingleImage+'" alt="article single image" class="w-100">' +
                            '                             </div>';
                    }
                    if($categoriesTxt){
                        $chtml += '' +
                            '<small class="bold">Categories : ' + $categoriesTxt.join(', ') + '</small>';
                    }
                    $chtml += '' +
                        '                             <div class="article-single-desc mt-4 col-12 m-0 p-0">';
                    if($articleHeadline) {
                    $chtml += '' +
                        '                                 <h3>' + $articleHeadline + '</h3>';
                    }
                    if($articleHtml){
                        $chtml += $articleHtml;
                    }
                    $chtml += '' +
                        '                             </div>' +
                        '                         </div>' +
                        '                     </div>' +
                        '                 </div>' +
                        '                 <div class="article-tags row p-3">' +
                        '                      <div class="col-md-12">';
                    $.each($articleTags, function($i, $v){
                    $chtml += '' +
                        '                           <div class="tag">'+$v.tag+'</div>';
                    });
                    $chtml += '' +
                        '                       </div>' +
                        '                  </div>' +
                        '             </div>' +
                        '         </div>' +
                        '     </div>' +
                        ' </div>' +
                        '</div>';
                    libs.checkImageLoad($($chtml).find('img'), function(){
                        $target.html($chtml).promise().done(function(){
                            $container.css('overflowY', 'auto')
                                .css('height', '93vh')
                                .css('margin', '1vh 0px');
                            //var $api = $gallery.ui.getFullscreenAPI();
                            //$api.enter();
                            $("body").css('overflowY', 'hidden');
                            $gallery.listen('close', function() {
                                $container.remove();
                                $("body").css('overflowY', 'scroll');
                                if(cback != undefined){
                                    cback();
                                }
                            });
                            var $scrollMousewheelBinding;
                            $(window).unbind('mousewheel').bind('mousewheel', function($e){
                                try{
                                    clearTimeout($scrollMousewheelBinding);
                                }catch ($e) {

                                }
                                $scrollMousewheelBinding = setTimeout(function(){
                                    if($e.originalEvent.wheelDelta / 120 > 0) {
                                        if($container.length > 0){
                                            $container.animate({
                                                scrollTop:'-=280'
                                            });
                                        }
                                    }else{
                                        if($container.length > 0){
                                            $container.animate({
                                                scrollTop:'+=280'
                                            });
                                        }
                                    }
                                }, 100);
                            });
                        });
                    });
                }
            },
        };

        //nlWallMenu
        var $nlWallMenuDefaults = {
            wall_menu_options_modal:function(){
                return $("#nurseslounge-home-activity-options-modal");
            },
            wall_menu_get:"/myDashboard/activity/wallOptionsMenu/get",
            wall_menu_set:"/myDashboard/activity/wallOptions/set",
        };
        if($nlWallMenuOptions != undefined){
            $nlWallMenuSettings = $.extend({}, $nlWallMenuDefaults, $nlWallMenuOptions);
        }else{
            $nlWallMenuSettings = $.extend({}, $nlWallMenuDefaults);
        }

        $nlWallMenuOriginal = $nlWallMenuDefaults;

        nlWallMenu = {
            init:function($id, $level, $options){
                $options = $options == undefined ? {} : $options;
                $options = $.extend({}, {
                    wall_container:function(){
                        return $("#nurseslounge-home-activity .nurseslounge-home-activity-left .wall-container");
                    },
                }, $options);
                nlWallMenu.get($id, $level, function($data){
                    var $wallPost = $data.data.wall_post;
                    var $dataOptions = $data.data.options;
                    var $id = $wallPost && $wallPost.id;
                    var $modal = $nlWallMenuSettings.wall_menu_options_modal();
                    var $modalInfo = $modal.find('.modal-info:first');
                    var $chtml = '';
                    if(!$modal.is(':visible')) {
                        $modal.unbind().on('hidden.bs.modal', function () {
                            $("body").css('overflowY', 'scroll');
                            $modal.css('overflowY', 'hidden');
                            var $player = libs.memoryGet('previewPlayer' + $id);
                            if($player){
                                $player.player.pause = true;
                                $player.destroy();
                                libs.memorySave('previewPlayer' + $id, false);
                            }
                        }).on('shown.bs.modal', function () {
                            $("body").css('overflowY', 'hidden');
                            $modal.css('overflowY', 'scroll');
                        })
                    }
                    $chtml = nlWallHtml.wall_menu_popup($wallPost, $dataOptions, 'readonly');
                    $modalInfo.html(nlWallHtml.wall_menu_preload()).promise().done(function(){
                        libs.checkImageLoad($($chtml).find('img'), function(){
                            $modalInfo.html($chtml).promise().done(function(){
                                nlWallMenu.preview($wallPost, $options, function(){
                                    nlWallMenu.events($id, $level, $wallPost, $options, function(){
                                        $modal.modal('show');
                                    });
                                });
                            });
                        });
                    });
                });
            },
            get:function($id, $level, cback){
                var $wallMenuGet = $nlWallMenuSettings.wall_menu_get;
                var $wallDebug = $nlWallSettings.wall_debug;
                var $withParams = $.extend({}, nlWallHelper.get_with_params(), {id:$id, level:$level});
                $.ajax({
                    url:$wallMenuGet,
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data:$withParams,
                    success: function ($data) {
                        libs.expire($data);
                        if($wallDebug){console.log($withParams);console.log($wallMenuGet);console.log($data);}
                        cback($data);
                    }
                });
            },
            preview:function($wallPost, $options, cback){
                var $modal = $nlWallMenuSettings.wall_menu_options_modal();
                var $target = $modal.find('.post-media');
                var $document = $wallPost && $wallPost.documents[0] && $wallPost.documents[0].document ? $wallPost.documents[0].document : null;
                if($document){
                    var $id = $wallPost && $wallPost.id;
                    var $type = $document ? $document.file_type : null;
                    var $preview = $document ? $document.document_preview_root : null;
                    var $thumb = $document ? $document.document_thumb_root : null;
                    var $name = $document ? $document.name : null;
                    var $documentId = $document ? $document.id : null;
                    if($type == 'document') {
                        setTimeout(function() {
                            if(PDFObject.supportsPDFs){
                                PDFObject.embed($preview, $target, {
                                    height: "300px",
                                    pdfOpenParams: {
                                        view: 'FitV',
                                        scrollbars: '0',
                                        toolbar: '0',
                                        statusbar: '0',
                                        navpanes: '0',
                                        page: '1'
                                    }
                                });
                            } else {
                                $target.html('<iframe id="pdfviewer" src="http://docs.google.com/gview?embedded=true&url='+$preview+'" frameborder="0" width="100%" height="100%"></iframe>');
                            }
                            libs.refreshTooltips();
                        }, 1000);
                    }
                    if($type == 'video') {
                        $target.height(300);
                        setTimeout(function(){
                            var $player = new Artplayer({
                                destroy: true,
                                container: $target[0],
                                title:  $name,
                                url:    $preview + '?temporal=true',
                                poster: $thumb,
                                type: 'mp4',
                                mutex: true,
                                muted: false,
                                play: true,
                                pause: false,
                                autoplay: true,
                                toggle: false,
                                //controls: [
                                //    {
                                //        position: 'right',
                                //        html: 'Fullscreen',
                                //        click: function () {
                                //            nlWallDocumentPreview.init($documentId);
                                //        },
                                //    },
                                //],
                                miniProgressBar: true,
                                loop: true,
                                fullscreen: false,
                                fullscreenToggle: false,
                                fullscreenWeb: false,
                                fullscreenWebToggle: false,
                                fullscreenRotate: false,
                                fullscreenRotateToggle: false,
                                moreVideoAttr: {
                                    crossOrigin: 'anonymous',
                                    playsInline: true,
                                    'webkit-playsinline': true,
                                    'x5-video-player-type': 'h5',
                                    'x5-video-player-fullscreen': false,
                                    'x5-video-orientation': 'portraint',
                                },
                                whitelist:['*']
                            }).on('ready', function () {
                                $player.player.pause = true;
                                $player.player.play = true;
                                libs.refreshTooltips();
                            });
                            $player.mask.show = false;
                            libs.memorySave('previewPlayer' + $id, $player);
                        }, 1000);
                    }
                }
                cback();
            },
            events:function($id, $level, $wallPost, $options, cback){
                var $modal = $nlWallMenuSettings.wall_menu_options_modal();
                var $menuOptions = $modal.find('.menu-options .option');
                var $postContent = $modal.find('.post-content');
                var $postMedia = $modal.find('.post-media');
                var $postMediaCancel = $postMedia.find('.cancel');
                $menuOptions.unbind().click(function(){
                    var $that = $(this);
                    var $action = $that.data('action');
                    switch($action){
                        case 'delete':
                            nlWallMenu.action($id, $level, $action, $options, function($dataWallSet){
                                var $wallContainer = $options.wall_container();
                                var $deletedIds = $dataWallSet.data.delete.deleted_ids;
                                var $parentId = $dataWallSet.data.delete.parent_wall ? $dataWallSet.data.delete.parent_wall.id : null;
                                var $commentsCount = $dataWallSet.data.delete.parent_wall ? $dataWallSet.data.delete.parent_wall.comments_count : 0;
                                $modal.modal('hide');
                                $wallContainer.find(".item").each(function(){
                                    var $this = $(this);
                                    var $id = $this.data('id');
                                    if($.inArray($id, $deletedIds) != -1){
                                        $wallContainer.find(".thread[data-id='"+$id+"']").fadeOut().remove();
                                        $wallContainer.find(".comments[data-id='"+$id+"']").fadeOut().remove();
                                        $wallContainer.find(".item[data-id='"+$id+"']").fadeOut().remove();
                                        if($parentId){
                                            $wallContainer.find(".comments-count[data-id='"+$parentId+"']").html($commentsCount);
                                        }
                                    }
                                });
                            });
                            break;
                        case 'edit':
                            nlWallMenu.action($id, $level, $action, $options, function($dataWallSet) {
                                nlWallMenu.edit($id, $level, $wallPost, $dataWallSet, $options);
                            });
                            break;
                        case 'save':
                            nlWallMenu.update($id, $level, $action, function($data){
                                var $wallPost = $data.data.save.wall_post;
                                var $chtml = '';
                                if($level == 0){
                                    var $comments = $options.wall_container().find(".comments[data-id='"+$id+"']")[0].outerHTML;
                                    var $thread = $options.wall_container().find(".open-thread[data-id='"+$id+"']")[0].outerHTML;
                                    $chtml = nlWallHtml.wall_menu_update_post($wallPost);
                                    $options.wall_container().find(".item[data-id='"+$id+"']").replaceWith($chtml);
                                    $options.wall_container().find(".comments[data-id='"+$id+"']").replaceWith($comments);
                                    $options.wall_container().find(".open-thread[data-id='"+$id+"']").replaceWith($thread);
                                }else{
                                    $chtml = nlWallHtml.wall_menu_update_thread($wallPost);
                                    $options.wall_container().find(".item[data-id='"+$id+"']").replaceWith($chtml);
                                }
                                if(!$notRun) {
                                    nlWall.init();
                                }
                                $modal.modal('hide');
                            });
                            break;
                        case 'attach':
                            nlWallUpdate.init({
                                wall_update_button:false,
                                wall_update_preload_target: function(){
                                    return $postMedia;
                                },
                                wall_update_target: function(){
                                    return $postMedia;
                                },
                                wall_update_text_area:function(){
                                    return $postContent;
                                },
                                on_close_modal_callback:function(){
                                    var $albumModal = $nlWallAlbumSettings.album_modal();
                                    $albumModal.modal('hide');
                                    var $optionsModal = $nlWallMenuSettings.wall_menu_options_modal();
                                    $optionsModal.modal('show');
                                },
                                on_end_callback:function(){
                                    var $updateModal = $nlWallUpdateSettings.wall_update_modal();
                                    $updateModal.modal('hide');
                                    var $optionsModal = $nlWallMenuSettings.wall_menu_options_modal();
                                    $optionsModal.modal('show');
                                },
                                get_data_callback:false,
                                wall_update_skip:[]
                            },function(){
                                $modal.modal('hide');
                            });
                            break;
                        case 'back':
                            nlWallMenu.init($id, $level, $options);
                            break;
                    }
                });
                nlWallRecognizeUrl.init({
                    wall_textarea: function(){
                        return $postContent;
                    },
                    recognize_url_preload_target: function(){
                        return $postMedia;
                    },
                    recognize_url_target: function(){
                        return $postMedia;
                    }
                }, function(){
                    $postMediaCancel.unbind().click(function(){
                        var $that = $(this);
                        $that.parents('.attach:first').remove();
                    });
                });
                libs.refreshTooltips();
                $modal.find('[data-link]').unbind().click(function() {
                    var $that = $(this);
                    var $link = $that.data('link');
                    $modal.modal('hide');
                    router.navigate($link,true);
                });
                if(cback != undefined){
                    cback();
                }
            },
            action:function($id, $level, $action, $options, cback){
                var $modal = $nlWallMenuSettings.wall_menu_options_modal();
                var $wallMenuSet = $nlWallMenuSettings.wall_menu_set;
                var $wallDebug = $nlWallSettings.wall_debug;
                var $withParams = $.extend({}, nlWallHelper.get_with_params(), {id:$id, level:$level, action:$action});
                $.ajax({
                    url:$wallMenuSet,
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data:$withParams,
                    success: function ($data) {
                        libs.expire($data);
                        if($wallDebug){console.log($withParams);console.log($wallMenuSet);console.log($data);}
                        if($data.status == 'success'){
                            cback($data);
                        }
                        if($data.status == 'error'){
                            $modal.modal('hide');
                        }
                    }
                });
            },
            edit:function($id, $level, $wallPost, $dataWallSet, $options){
                var $dataOptions = $dataWallSet.data.options;
                var $modal = $nlWallMenuSettings.wall_menu_options_modal();
                var $modalInfo = $modal.find('.modal-info:first');
                var $chtml = '';
                $chtml = nlWallHtml.wall_menu_popup($wallPost, $dataOptions);
                $modalInfo.html(nlWallHtml.wall_menu_preload()).promise().done(function() {
                    libs.checkImageLoad($($chtml).find('img'), function(){
                        $modalInfo.html($chtml).promise().done(function(){
                            nlWallMenu.events($id, $level, $wallPost, $options);
                        });
                    });
                });
            },
            update:function($id, $level, $action, cback){
                var $modal = $nlWallMenuSettings.wall_menu_options_modal();
                var $postMedia = $modal.find('.post-media');
                var $postContent = $modal.find('.post-content');
                var $post = $postContent.val();
                var $urls = [];
                var $documents = [];
                $postMedia.find("> div").each(function(){
                    var $that = $(this);
                    if($that.data('type') == 'website-thumb'){
                        $urls.push($(this).data('url'));
                    }
                    if($that.data('type') == 'website-document'){
                        $documents.push($(this).data('id'));
                    }
                });
                nlWallMenu.set($id, $level, $post, $urls, $documents, 'save', cback);
            },
            set:function($id, $level, $post, $urls, $documents, $action, cback){
                var $modal = $nlWallMenuSettings.wall_menu_options_modal();
                var $wallMenuSet = $nlWallMenuSettings.wall_menu_set;
                var $wallDebug = $nlWallSettings.wall_debug;
                var $withParams = $.extend({}, nlWallHelper.get_with_params(), {id:$id, level:$level, post:$post, urls:$urls, documents:$documents, action:$action});
                $.ajax({
                    url:$wallMenuSet,
                    method: "POST",
                    cache:false,
                    dataType: "json",
                    data:$withParams,
                    success: function ($data) {
                        libs.expire($data);
                        if($wallDebug){console.log($withParams);console.log($wallMenuSet);console.log($data);}
                        if($data.status == 'success'){
                            cback($data);
                        }
                        if($data.status == 'error'){
                            $modal.modal('hide');
                        }
                    }
                });
            },
        };

        if(!$notRun){
            nlWall.init();
        }
    };
    $.fn.nurseslounge_myDashboard_wall_get = function($params, $search){
        var $arr = [];
        var $selected;
        $(window).nurseslounge_myDashboard_wall(
            $params,
            {},
            {},
            {},
            {},
            {},
            {},
            true
        );
        $arr.push(['nlWall', nlWall]);
        $arr.push(['nlWallRecognizeUrl', nlWallRecognizeUrl]);
        $arr.push(['nlWallUpdate', nlWallUpdate]);
        $arr.push(['nlWallAlbum', nlWallAlbum]);
        $arr.push(['nlWallDocumentPreview', nlWallDocumentPreview]);
        $arr.push(['nlWallMenuOriginal', $nlWallMenuOriginal]);
        $.each($arr, function($i, $v){
            if($v[0] == $search){
                $selected = $v[1];
                return false;
            }
        });
        return $selected;
    }
})(jQuery);
